import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import LoadingOverlay from "react-loading-overlay-ts";
import { ReactComponent as LeftArrow } from "../../../../Assets/common/images/leftArrow.svg";
import {
  getConsultationDetail,
  retryConsultation,
  selectCurrentConsultation,
  selectCurrentLoadingConsultDetail,
  setCurrentConsultationDetail,
} from "../listasSlice";
import { useNavigate, useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { formatDateStandar } from "../../../../helpers/utils";
import Modal, { Styles } from "react-modal";
import {
  AccidentalidadBogota,
  ConsultationResultDetail,
  ContaduriaData,
  DefuncionesRegistraduria,
  GarantiaMobiliaria,
  getPdfReportAPI,
  getPdfTusDatosAPI,
  Hallazgo,
  ImpuestoVehiculo,
  JuzgadoTyba,
  LibretaMilitar,
  LibretaMilitarDetalle,
  ListaBancoMundial,
  MatriculaEstado,
  OffshoreLeaks,
  Rama,
  RamaUnificada,
  RegistraduriaCertificado,
  RevisionTM,
  Rndc,
  Ruaf,
  RuntApp,
  RuntData,
  Simit,
  Simur,
  Sisben,
  Sisconmp,
  Soat,
  VehiculoResult,
  VUSInmov,
} from "../externalInfoAPI";
import { ReactComponent as InfoIcon } from "../../../../Assets/common/images/infoDynamic.svg";
import { ReactComponent as WarningIcon } from "../../../../Assets/common/images/warningDynamic.svg";
import { ReactComponent as DownloadIcon2 } from "../../../../Assets/common/images/downloadIcon2.svg";
import { ExpandibleContent } from "../../components/ExpandibleContent";

Modal.setAppElement("#root");

const customStylesModalVehicleDetail: Styles = {
  content: {
    top: "50%",
    left: "55%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "40%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.5)",
  },
};

const customStylesModalHallazgos: Styles = {
  content: {
    top: "50%",
    left: "55%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "80%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.5)",
  },
};
export const ConsultationDetail = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const detailLoading = useAppSelector(selectCurrentLoadingConsultDetail);
  const currentConsultationDetail = useAppSelector(selectCurrentConsultation);

  const [showVehicleDetailModal, setShowVehicleDetailModal] = useState(false);
  const [showHallazgosDetailModal, setShowHallazgosDetailModal] =
    useState(false);
  const [selectedHallazgos, setSelectedHallazgos] = useState<Hallazgo[]>([]);
  const [expandedElementId, setExpandedElementId] = useState<string | null>(
    null
  );
  const [loadingPdf, setLoadingPdf] = useState(false);

  const ramaJudicialNames = (ramaName: string) => {
    switch (ramaName) {
      case "armeniajepms":
        return "Rama Judicial Armenia";
      case "barranquillajepms":
        return "Rama Judicial Barranquilla";
      case "bogotajepms":
        return "Rama Judicial Bogota";
      case "bucaramangajepms":
        return "Rama Judicial Bucaramanga";
      case "bugajepms":
        return "Rama Judicial Bucaramanga";
      case "calijepms":
        return "Rama Judicial Cali";
      case "cartagenajepms":
        return "Rama Judicial Cartagena";
      case "florenciajepms":
        return "Rama Judicial Florencia";
      case "ibaguejepms":
        return "Rama Judicial Ibague";
      case "ladoradajepms":
        return "Rama Judicial La Dorada";
      case "manizalesjepms":
        return "Rama Judicial Manizales";
      case "medellinjepms":
        return "Rama Judicial Medellin";
      case "monteriajepms":
        return "Rama Judicial Monteria";
      case "neivajepms":
        return "Rama Judicial Neiva";
      case "palmirajepms":
        return "Rama Judicial Palmira";
      case "pastojepms":
        return "Rama Judicial Pasto";
      case "pereirajepms":
        return "Rama Judicial Pereira";
      case "popayanjepms":
        return "Rama Judicial Popayan";
      case "quibdojepms":
        return "Rama Judicial Quibdo";
      case "santamartajepms":
        return "Rama Judicial Santa Marta";
      case "tunjajepms":
        return "Rama Judicial Tunja";
      case "valleduparjepms":
        return "Rama Judicial Valledupar";
      case "villavicenciojepms":
        return "Rama Judicial Villavicencio";
      default:
        return ramaName;
    }
  };

  const rndcResult = (rndcData: Rndc[] | undefined | "Error") => {
    if (!rndcData)
      return (
        <div>
          <h1 style={{ color: "white" }}>No hay datos de RNDC</h1>
        </div>
      );
    if (rndcData === "Error") {
      return (
        <div>
          <h1 style={{ color: "white" }}>Error al obtener los datos de RNDC</h1>
        </div>
      );
    }
    return (
      <div
        style={{
          width: "100%",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          maxHeight: "500px",
          padding: "20px",
        }}
      >
        <h6 style={{ color: "white", fontWeight: 600, fontSize: "15px" }}>
          Lista de viajes RNDC
        </h6>
        <table style={{ marginTop: "10px", width: "100%" }}>
          <thead>
            <th style={{ color: "white", fontWeight: 600 }}>
              Cedula conductor
            </th>
            <th style={{ color: "white", fontWeight: 600 }}>Consecutivo</th>
            <th style={{ color: "white", fontWeight: 600 }}>Destino</th>
            <th style={{ color: "white", fontWeight: 600 }}>Estado</th>
            <th style={{ color: "white", fontWeight: 600 }}>
              Fecha Expedición
            </th>
            <th style={{ color: "white", fontWeight: 600 }}>
              Fecha y hora de radicación
            </th>
            <th style={{ color: "white", fontWeight: 600 }}>
              Nombre Empresa Transportadora
            </th>
            <th style={{ color: "white", fontWeight: 600 }}>Nro de Radicado</th>
            <th style={{ color: "white", fontWeight: 600 }}>Origen</th>
            <th style={{ color: "white", fontWeight: 600 }}>Placa</th>
            <th style={{ color: "white", fontWeight: 600 }}>
              Placa de remolque
            </th>
            <th style={{ color: "white", fontWeight: 600 }}>
              Tipo de documento
            </th>
          </thead>
          <tbody style={{ overflow: "auto" }}>
            {rndcData.map((rndcItem, index) => {
              return (
                <tr
                  key={index}
                  style={{ border: "1px solid rgba(255,255,255,0.8)" }}
                >
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Cedula Conductor"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Consecutivo"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Destino"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Estado"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Fecha Exped"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Fecha Hora Radicación"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Nombre Empresa Transportadora"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Nro de Radicado"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Origen"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Placa"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Placa Remolque"]}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {rndcItem["Tipo Doc"]}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const ramaUnificadaResult = (
    ramaUnificadaData: RamaUnificada[] | undefined | null | "Error"
  ) => {
    if (
      !ramaUnificadaData ||
      ramaUnificadaData.length === 0 ||
      ramaUnificadaData === "Error"
    ) {
      if (ramaUnificadaData && ramaUnificadaData.length === 0) {
        return (
          <p style={{ color: "white" }}>No hay información de rama judicial</p>
        );
      } else {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de rama judicial
          </p>
        );
      }
    }
    return (
      <div
        style={{
          width: "100%",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          maxHeight: "500px",
          padding: "20px",
        }}
      >
        <h6 style={{ color: "white", fontWeight: 600, fontSize: "15px" }}>
          Rama Unificada
        </h6>
        <table style={{ marginTop: "10px", width: "100%" }}>
          <thead>
            <th style={{ color: "white", fontWeight: 600 }}>Clase Proceso</th>
            <th style={{ color: "white", fontWeight: 600 }}>Demandado</th>
            <th style={{ color: "white", fontWeight: 600 }}>Demandante</th>
            <th style={{ color: "white", fontWeight: 600 }}>Departamento</th>
            <th style={{ color: "white", fontWeight: 600 }}>Despacho</th>
            <th style={{ color: "white", fontWeight: 600 }}>
              Contenido Radicación
            </th>
          </thead>
          <tbody style={{ overflow: "auto" }}>
            {ramaUnificadaData.map((ramaUnificadaItem, index) => {
              return (
                <tr
                  key={index}
                  style={{ border: "1px solid rgba(255,255,255,0.8)" }}
                >
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {ramaUnificadaItem.claseProceso}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {ramaUnificadaItem.demandado}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {ramaUnificadaItem.demandante}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {ramaUnificadaItem.departamento}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {ramaUnificadaItem.despacho}
                  </td>
                  <td
                    style={{
                      color: "white",
                      fontWeight: 500,
                      fontSize: "15px",
                      border: "1px solid rgba(255,255,255,0.2)",
                    }}
                  >
                    {ramaUnificadaItem.contenidoRadicacion}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const ramaResult = (rama: Rama | undefined | null | "Error") => {
    if (!rama || rama === "Error") {
      if (rama === "Error") {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de rama judicial
          </p>
        );
      }
      return (
        <div>
          <h1 style={{ color: "white" }}>No hay datos de Rama Judicial</h1>
        </div>
      );
    }
    const ramaData = Object.entries(rama);
    if (ramaData.length === 0) {
      return (
        <div>
          <h1 style={{ color: "white" }}>No hay datos de Rama Judicial</h1>
        </div>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflow: "auto",
          maxHeight: "500px",
          padding: "15px",
        }}
      >
        {ramaData.map((ramaItem, index) => {
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <h6 style={{ color: "white", fontWeight: 600, fontSize: "16px" }}>
                {ramaJudicialNames(ramaItem[0])}
              </h6>
              {typeof ramaItem[1] === "object" ? (
                Object.entries(ramaItem[1]).map((ramaItem2, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <h6 style={{ color: "white", fontWeight: 500 }}>
                        Radicación {ramaItem2[0]}
                      </h6>
                      <table>
                        <thead>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            Clase Proceso
                          </th>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            Identificación Condenado
                          </th>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            Nombre Condenado
                          </th>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            Delitos
                          </th>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            No. Radicación
                          </th>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            Privado de la libertad
                          </th>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            Pena Privativa de la libertad
                          </th>
                          <th style={{ color: "white", fontWeight: 600 }}>
                            Privado de la libertad desde
                          </th>
                        </thead>
                        <tbody>
                          <tr key={index}>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {ramaItem2[1]["clase proceso"] &&
                                ramaItem2[1]["clase proceso"]["clase"]}
                            </td>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {ramaItem2[1]["condenados"] &&
                                ramaItem2[1]["condenados"][0]["identificacion"]}
                            </td>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {ramaItem2[1]["condenados"] &&
                                ramaItem2[1]["condenados"][1][
                                  "nombre del condenado"
                                ]}
                            </td>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {ramaItem2[1]["delitos"]}
                            </td>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {ramaItem2[1]["numero unico radicacion"] &&
                                ramaItem2[1]["numero unico radicacion"][
                                  "radicacion"
                                ]}
                            </td>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {ramaItem2[1]["privado de la libertad"]}
                            </td>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {`${
                                ramaItem2[1]["pena privativa de la libertad"] &&
                                ramaItem2[1]["pena privativa de la libertad"][
                                  "años"
                                ]
                              } Años ${
                                ramaItem2[1]["pena privativa de la libertad"] &&
                                ramaItem2[1]["pena privativa de la libertad"][
                                  "meses"
                                ]
                              } Meses ${
                                ramaItem2[1]["pena privativa de la libertad"] &&
                                ramaItem2[1]["pena privativa de la libertad"][
                                  "dias"
                                ]
                              } Dias`}
                            </td>
                            <td
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "15px",
                                border: "1px solid rgba(255,255,255,0.2)",
                              }}
                            >
                              {ramaItem2[1]["privado de la libertad desde"]}
                            </td>
                          </tr>
                          );
                        </tbody>
                      </table>
                    </div>
                  );
                })
              ) : (
                <p style={{ color: "white" }}>
                  {ramaItem[1] === "Error"
                    ? "Hubo un error con la fuente"
                    : "Sin información"}
                </p>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const runtAppResult = (runtData: RuntApp | null | undefined | "Error") => {
    if (!runtData || runtData === "Error") {
      if (runtData && runtData === "Error") {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de Runt
          </p>
        );
      }
      return (
        <p style={{ color: "red" }}>
          Hubo un error obteniendo información de Runt
        </p>
      );
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflow: "auto",
          maxHeight: "500px",
          padding: "15px",
        }}
      >
        {runtData.nombres && (
          <h5 style={{ fontSize: "14px", fontWeight: 500, color: "white" }}>
            {runtData.nombres}
          </h5>
        )}

        {runtData.licencia && (
          <h5 style={{ fontSize: "14px", fontWeight: 600, color: "white" }}>
            Licencias
          </h5>
        )}

        {runtData.licencia && (
          <h5 style={{ fontSize: "14px", fontWeight: 500, color: "white" }}>
            No. de Licencias: {runtData.licencia.totalLicencias}
          </h5>
        )}
        {runtData.licencia && (
          <table>
            <thead>
              <tr>
                <th style={{ color: "white", fontWeight: 600 }}>Categoria</th>
                <th style={{ color: "white", fontWeight: 600 }}>Estado</th>
                <th style={{ color: "white", fontWeight: 600 }}>
                  Fecha de expedición
                </th>
                <th style={{ color: "white", fontWeight: 600 }}>
                  Fecha de vencimiento
                </th>
                <th style={{ color: "white", fontWeight: 600 }}>
                  No. Licencia
                </th>
                <th style={{ color: "white", fontWeight: 600 }}>Sustrato</th>
              </tr>
            </thead>
            <tbody>
              {runtData.licencia.licencias.map((licenciaItem, index) => {
                return (
                  <tr key={index}>
                    <td
                      style={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: "15px",
                        border: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      {licenciaItem.categoria}
                    </td>
                    <td
                      style={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: "15px",
                        border: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      {licenciaItem.estado}
                    </td>
                    <td
                      style={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: "15px",
                        border: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      {licenciaItem.fecha_expedicion}
                    </td>
                    <td
                      style={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: "15px",
                        border: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      {licenciaItem.fecha_vencimiento}
                    </td>
                    <td
                      style={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: "15px",
                        border: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      {licenciaItem.numero_licencia}
                    </td>
                    <td
                      style={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: "15px",
                        border: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      {licenciaItem.sustrato}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {runtData.multa && (
          <h5
            style={{
              fontSize: "14px",
              fontWeight: 600,
              color: "white",
              marginTop: "10px",
            }}
          >
            Resumen Multas
          </h5>
        )}
        {runtData.multa && (
          <table>
            <thead>
              <tr>
                <th style={{ color: "white", fontWeight: 600 }}>
                  Estado cancelación
                </th>
                <th style={{ color: "white", fontWeight: 600 }}>
                  Estado Paz y Salvo
                </th>
              </tr>
            </thead>
            <tbody>
              <td style={{ color: "white", fontWeight: 500, fontSize: "15px" }}>
                {runtData.multa.estado_cancelacion || "Ninguno"}
              </td>
              <td style={{ color: "white", fontWeight: 500, fontSize: "15px" }}>
                {runtData.multa.estado_paz_salvo}
              </td>
              <td
                style={{ color: "white", fontWeight: 500, fontSize: "15px" }}
              ></td>
            </tbody>
          </table>
        )}
      </div>
    );
  };

  const garantiasMobiliariasResult = (
    garantias: GarantiaMobiliaria[] | "Error"
  ) => {
    if (!garantias || garantias.length === 0 || garantias === "Error") {
      return <p style={{ color: "white" }}>No hay garantías registradas</p>;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Garantías Mobiliarias</h3>

        {garantias.map((g, index) => (
          <div
            key={index}
            style={{
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "8px",
              padding: "12px",
            }}
          >
            {g.Detalles.Acreedor && (
              <p>
                <strong>Acreedor:</strong>{" "}
                {g.Detalles.Acreedor["Razón Social o Nombre"]}
              </p>
            )}

            {g.Detalles.Deudor && (
              <p>
                <strong>Deudor:</strong>{" "}
                {g.Detalles.Deudor["Razón Social o Nombre"]}
              </p>
            )}

            {g.Detalles["Info general"] && (
              <p>
                <strong>Tipo de garantía:</strong>{" "}
                {g.Detalles["Info general"]["Tipo Garantía"]}
              </p>
            )}
            {g.Detalles["Info general"] && (
              <p>
                <strong>Monto máximo:</strong>{" "}
                {
                  g.Detalles["Info general"][
                    "Monto Máximo de la obligación garantizada"
                  ]
                }
              </p>
            )}

            {g.Detalles["Info general"] && (
              <p>
                <strong>Fecha finalización:</strong>{" "}
                {g.Detalles["Info general"]["Fecha Finalización"]}
              </p>
            )}
            {g.Detalles["Bienes garantizados"] && (
              <div style={{ marginTop: "8px" }}>
                <p>
                  <strong>Bien:</strong>{" "}
                  {g.Detalles["Bienes garantizados"].Marca} -{" "}
                  {
                    g.Detalles["Bienes garantizados"][
                      "Año Correspondiente al Modelo"
                    ]
                  }
                </p>
                <p style={{ fontSize: "13px", opacity: 0.8 }}>
                  {g.Detalles["Bienes garantizados"]["Descripción del Bien"]}
                </p>
              </div>
            )}

            {g["Folio Electrónica"] && (
              <p style={{ fontSize: "12px", opacity: 0.6, marginTop: "6px" }}>
                Folio: {g["Folio Electrónico"]}
              </p>
            )}
            {g["Fecha de inscripción inicial"] && (
              <p style={{ fontSize: "12px", opacity: 0.6 }}>
                Fecha registro: {g["Fecha de inscripción inicial"]}
              </p>
            )}
          </div>
        ))}
      </div>
    );
  };

  const sisconmpResult = (data: Sisconmp | "Error" | null) => {
    if (!data || data === "Error") {
      return <p style={{ color: "white" }}>No hay información de SISCONMP</p>;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>SISCONMP</h3>

        <div
          style={{
            border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: "8px",
            padding: "12px",
          }}
        >
          <p>
            <strong>Nombre:</strong> {data.Nombres} {data.Apellidos}
          </p>

          <p>
            <strong>Tipo documento:</strong> {data.TDI}
          </p>

          <p>
            <strong>Número documento:</strong> {data.NDI}
          </p>

          <p>
            <strong>Licencia:</strong> {data.NumeroLicencia}
          </p>

          <p>
            <strong>Institución:</strong> {data.InstitucionEducativa}
          </p>

          <p>
            <strong>Sede:</strong> {data.NombreSede} ({data.DIVNOMBRSede})
          </p>

          <p>
            <strong>Capacitación:</strong> {data.NombreCapacitacion}
          </p>

          <p>
            <strong>Tipo capacitación:</strong> {data.TipoCapacitacion}
          </p>

          <p>
            <strong>Entidad certificadora:</strong> {data.EntidadCertificadora}
          </p>

          <p>
            <strong>Fecha expedición:</strong> {data.FechaExpedicion}
          </p>

          <p>
            <strong>Fecha vencimiento:</strong> {data.FechaVencimiento}
          </p>

          <p>
            <strong>Estado:</strong> {data.Inactivo}
          </p>

          {data["TipoVehiculo"] && (
            <p>
              <strong>Tipo vehículo:</strong> {data.TipoVehiculo}
            </p>
          )}

          {data["Clase"] && (
            <p>
              <strong>Clase:</strong> {data.Clase}
            </p>
          )}

          <p style={{ fontSize: "12px", opacity: 0.6, marginTop: "6px" }}>
            Registro: {data.FechaRegistro}
          </p>

          <p style={{ fontSize: "12px", opacity: 0.6 }}>
            Vigencia licencia: {data.FechaVencimientoLicencia}
          </p>
        </div>
      </div>
    );
  };

  const contaduriaHallazgoResult = (contaduriaHallazgo: string) => {
    if (
      !contaduriaHallazgo ||
      contaduriaHallazgo.length === 0 ||
      contaduriaHallazgo === "Error"
    ) {
      return <p style={{ color: "white" }}>No hay hallazgos registrados</p>;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Evidencia Contaduria</h3>
        <p style={{ fontWeight: 600 }}>Click aqui para ver la evidencia</p>
        <p>{contaduriaHallazgo}</p>
      </div>
    );
  };

  const contaduriaPdfResult = (contaduriaPdf: string) => {
    if (
      !contaduriaPdf ||
      contaduriaPdf.length === 0 ||
      contaduriaPdf === "Error"
    ) {
      return <p style={{ color: "white" }}>No hay hallazgos registrados</p>;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Contaduria Pdf</h3>
        <a href={contaduriaPdf}>{contaduriaPdf}</a>
      </div>
    );
  };

  const libretaMilitarResult = (
    libretaMilitar: LibretaMilitar | LibretaMilitarDetalle | string
  ) => {
    if (!libretaMilitar || libretaMilitar === "Error") {
      return (
        <p style={{ color: "white" }}>
          No hay información de la libreta militar
        </p>
      );
    }
    if (typeof libretaMilitar === "string") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            maxHeight: "500px",
            overflow: "auto",
            padding: "10px",
            color: "white",
          }}
        >
          <p>{libretaMilitar}</p>
        </div>
      );
    } else if ("info" in libretaMilitar) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            maxHeight: "500px",
            overflow: "auto",
            padding: "10px",
            color: "white",
          }}
        >
          <h3 style={{ fontWeight: 600 }}>Libreta Militar</h3>
          <p>{libretaMilitar.info}</p>
        </div>
      );
    } else {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            maxHeight: "500px",
            overflow: "auto",
            padding: "10px",
            color: "white",
          }}
        >
          <p>Clase: {libretaMilitar.clase}</p>
          <p>Documento: {libretaMilitar.documento}</p>
          <p>Nombre: {libretaMilitar.nombre}</p>
          <p>Tipo: {libretaMilitar.tipo_documento}</p>
        </div>
      );
    }
  };

  const juzgadosTybaResult = (
    juzgados_tyba?: JuzgadoTyba[] | "Error" | null
  ) => {
    if (
      !juzgados_tyba ||
      juzgados_tyba === "Error" ||
      juzgados_tyba.length === 0
    ) {
      return (
        <p style={{ color: "white" }}>No hay procesos judiciales registrados</p>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Procesos Judiciales</h3>

        {juzgados_tyba.map((proceso, index) => {
          const info = proceso?.["INFO PROCES0"];

          return (
            <div
              key={index}
              style={{
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "8px",
                padding: "12px",
              }}
            >
              <p>
                <strong>Código proceso:</strong>{" "}
                {proceso?.["CODIGO PROCESO"] ?? "N/A"}
              </p>

              <p>
                <strong>Ciudad:</strong> {proceso?.["CIUDAD PROCESO"] ?? "N/A"}
              </p>

              <p>
                <strong>Departamento:</strong>{" "}
                {proceso?.["DEPARTAMENTO PROCESO"] ?? "N/A"}
              </p>

              <p>
                <strong>Despacho:</strong> {proceso?.DESPACHO ?? "N/A"}
              </p>

              <p>
                <strong>Clase proceso:</strong>{" "}
                {proceso?.["CLASE PROCESO"] ?? "N/A"}
              </p>

              {/* INFO GENERAL */}
              <div style={{ marginTop: "10px" }}>
                <p>
                  <strong>Tipo proceso:</strong>{" "}
                  {info?.["Tipo Proceso"] ?? "N/A"}
                </p>

                <p>
                  <strong>Fecha publicación:</strong>{" "}
                  {info?.["Fecha Publicación"] ?? "N/A"}
                </p>

                <p>
                  <strong>Dirección:</strong> {info?.["Dirección"] ?? "N/A"}
                </p>

                <p>
                  <strong>Teléfono:</strong> {info?.["Teléfono"] ?? "N/A"}
                </p>
              </div>

              {/* ACTUACIONES */}
              {info?.actuaciones?.length ? (
                <div style={{ marginTop: "12px" }}>
                  <p>
                    <strong>Actuaciones:</strong>
                  </p>

                  {info.actuaciones.slice(0, 5).map((act, i) => (
                    <div key={i} style={{ fontSize: "13px", opacity: 0.8 }}>
                      <p>
                        {act?.["FECHA ACTUACIÓN"] ?? "Sin fecha"} -{" "}
                        {act?.["TIPO ACTUACIÓN"] ?? "Sin detalle"}
                      </p>
                    </div>
                  ))}
                </div>
              ) : null}

              {/* SUJETOS */}
              {info?.sujetos?.length ? (
                <div style={{ marginTop: "12px" }}>
                  <p>
                    <strong>Sujetos:</strong>
                  </p>

                  {info.sujetos.slice(0, 5).map((suj, i) => (
                    <div key={i} style={{ fontSize: "13px", opacity: 0.8 }}>
                      <p>
                        {suj?.["NOMBRE(S) Y APELLIDO(S) / RAZÓN SOCIAL"] ??
                          "Sin nombre"}{" "}
                        - {suj?.["TIPO SUJETO"] ?? "Sin tipo"}
                      </p>
                    </div>
                  ))}
                </div>
              ) : null}

              {/* FOOTER */}
              <p style={{ fontSize: "12px", opacity: 0.6, marginTop: "8px" }}>
                Estado:{" "}
                {proceso?.proceso_privado === true
                  ? "Privado"
                  : proceso?.proceso_privado === false
                  ? "Público"
                  : "N/A"}
              </p>
            </div>
          );
        })}
      </div>
    );
  };

  const accidentalidadBogResult = (
    accidentalidad: AccidentalidadBogota[] | "Error" | null
  ) => {
    if (
      !accidentalidad ||
      accidentalidad === "Error" ||
      accidentalidad.length === 0
    ) {
      if (accidentalidad && accidentalidad.length === 0) {
        return (
          <p style={{ color: "white" }}>No hay información de accidentalidad</p>
        );
      } else {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de accidentalidad
          </p>
        );
      }
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Accidentalidad Bogotá</h3>

        {accidentalidad.map((acc, i) => (
          <div key={i}>{acc.toString()}</div>
        ))}
      </div>
    );
  };

  const impuestosVehiculoResult = (
    impuestosVehiculo: ImpuestoVehiculo[] | "Error" | null
  ) => {
    if (
      !impuestosVehiculo ||
      impuestosVehiculo === "Error" ||
      impuestosVehiculo.length === 0
    ) {
      if (impuestosVehiculo && impuestosVehiculo.length === 0) {
        return (
          <p style={{ color: "white" }}>No hay información de impuestos</p>
        );
      } else {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de impuestos
          </p>
        );
      }
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Impuestos Vehiculo</h3>

        {impuestosVehiculo.map((imp, i) => (
          <div key={i}>
            {imp.Response || "no se encontró información de impuestos"}
          </div>
        ))}
      </div>
    );
  };

  const matriculaEstadoResult = (
    matriculaEstado: MatriculaEstado | "Error" | null
  ) => {
    if (!matriculaEstado || matriculaEstado === "Error") {
      return (
        <p style={{ color: "red" }}>
          Hubo un error obteniendo información de matricula
        </p>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Estado de la matrícula</h3>

        <div>{matriculaEstado.estado_matricula}</div>
      </div>
    );
  };

  const omisionesVehiculosResult = (
    data: string | "Error" | undefined | null
  ) => {
    if (data === "Error") {
      return (
        <p style={{ color: "red" }}>
          Hubo un error obteniendo información de omisiones
        </p>
      );
    } else if (!data) {
      return <p style={{ color: "white" }}>No hay información de omisiones</p>;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Omisiones al vehículo</h3>

        <div>{data}</div>
      </div>
    );
  };

  const runtResult = (data: RuntData | "Error" | null) => {
    if (!data || data === "Error") {
      return <p style={{ color: "white" }}>No se encontró información RUNT</p>;
    }

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const subCardStyle = {
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px",
      padding: "10px",
      marginTop: "10px",
      background: "rgba(255,255,255,0.02)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string) =>
      v && v.trim() !== "" ? v : "Sin información";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información RUNT</h3>

        {/* GENERAL */}
        <div style={cardStyle}>
          <div style={titleStyle}>Datos Generales</div>
          <p>
            <strong>Placa:</strong> {empty(data?.placa)}
          </p>
          <p>
            <strong>Marca:</strong> {empty(data?.marca)}
          </p>
          <p>
            <strong>Línea:</strong> {empty(data?.linea)}
          </p>
          <p>
            <strong>Modelo:</strong> {empty(data?.modelo)}
          </p>
          <p>
            <strong>Clase:</strong> {empty(data?.clase_vehiculo)}
          </p>
          <p>
            <strong>Color:</strong> {empty(data?.color)}
          </p>
          <p>
            <strong>Servicio:</strong> {empty(data?.tipo_servicio)}
          </p>
        </div>

        {/* SOAT */}
        <div style={cardStyle}>
          <div style={titleStyle}>SOAT</div>

          {data?.info_soat?.length ? (
            data.info_soat.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Póliza #{i + 1}</strong>
                </p>
                <p>
                  <strong>Entidad:</strong> {empty(item?.entidad_expide)}
                </p>
                <p>
                  <strong>Estado:</strong> {empty(item?.estado)}
                </p>
                <p>
                  <strong>Número:</strong> {empty(item?.no_soat)}
                </p>
                <p>
                  <strong>Inicio:</strong> {empty(item?.fecha_inicio)}
                </p>
                <p>
                  <strong>Fin:</strong> {empty(item?.fecha_fin)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontró información del SOAT</p>
          )}
        </div>

        {/* TECNICOMECANICA */}
        <div style={cardStyle}>
          <div style={titleStyle}>Revisión Técnico Mecánica</div>

          {data?.info_tecnico_mecanica?.length ? (
            data.info_tecnico_mecanica.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Revisión #{i + 1}</strong>
                </p>
                <p>
                  <strong>CDA:</strong> {empty(item?.cda_expide)}
                </p>
                <p>
                  <strong>Certificado:</strong> {empty(item?.nro_certificado)}
                </p>
                <p>
                  <strong>Fecha:</strong> {empty(item?.fecha_exp)}
                </p>
                <p>
                  <strong>Vence:</strong> {empty(item?.fecha_vigencia)}
                </p>
                <p>
                  <strong>Vigente:</strong> {empty(item?.vigente)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontró revisión técnico mecánica</p>
          )}
        </div>

        {/* LIMITACIONES */}
        <div style={cardStyle}>
          <div style={titleStyle}>Limitaciones a la Propiedad</div>

          {data?.info_limitacion_propiedad?.length ? (
            data.info_limitacion_propiedad.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Registro #{i + 1}</strong>
                </p>
                <p>
                  <strong>Tipo:</strong> {empty(item?.tipo_limitacion)}
                </p>
                <p>
                  <strong>Entidad:</strong> {empty(item?.entidad_juridica)}
                </p>
                <p>
                  <strong>Municipio:</strong> {empty(item?.municipio)}
                </p>
                <p>
                  <strong>Departamento:</strong> {empty(item?.departamento)}
                </p>
                <p>
                  <strong>Fecha registro:</strong> {empty(item?.fecha_registro)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontraron limitaciones</p>
          )}
        </div>

        {/* GARANTIAS */}
        <div style={cardStyle}>
          <div style={titleStyle}>Garantías a Favor</div>

          {data?.info_garantias_a_favor?.length ? (
            data.info_garantias_a_favor.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Garantía #{i + 1}</strong>
                </p>
                <p>
                  <strong>Acreedor:</strong> {empty(item?.acreedor)}
                </p>
                <p>
                  <strong>Identificación:</strong>{" "}
                  {empty(item?.identificacion_acreedor)}
                </p>
                <p>
                  <strong>Fecha inscripción:</strong>{" "}
                  {empty(item?.fecha_inscripcion)}
                </p>
                <p>
                  <strong>Confecámaras:</strong> {empty(item?.confecamaras)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontraron garantías</p>
          )}
        </div>

        {/* NORMALIZACION */}
        <div style={cardStyle}>
          <div style={titleStyle}>Normalización</div>

          {data?.info_normalizacion?.length ? (
            data.info_normalizacion.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Registro #{i + 1}</strong>
                </p>
                <p>
                  <strong>Vehículo normalizado:</strong>{" "}
                  {empty(item?.vehiculo_normalizado)}
                </p>
                <p>
                  <strong>Deficiencia:</strong>{" "}
                  {empty(item?.deficiencia_matricula)}
                </p>
                <p>
                  <strong>Fecha:</strong> {empty(item?.fecha_normalizacion)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontró información de normalización</p>
          )}
        </div>

        {/* SOLICITUDES */}
        <div style={cardStyle}>
          <div style={titleStyle}>Solicitudes</div>

          {data?.info_solicitudes?.length ? (
            data.info_solicitudes.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Solicitud #{i + 1}</strong>
                </p>
                <p>
                  <strong>Entidad:</strong> {empty(item?.entidad)}
                </p>
                <p>
                  <strong>Estado:</strong> {empty(item?.estado)}
                </p>
                <p>
                  <strong>Fecha:</strong> {empty(item?.fecha_solicitud)}
                </p>
                <p>
                  <strong>Número:</strong> {empty(item?.nro_solicitud)}
                </p>
                <p>
                  <strong>Trámite:</strong> {empty(item?.tramites)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontraron solicitudes</p>
          )}
        </div>

        {/* POLIZA */}
        <div style={cardStyle}>
          <div style={titleStyle}>Póliza Caución</div>
          <p>
            <strong>Estado:</strong>{" "}
            {empty(data?.info_poliza_caucion?.estado_poliza)}
          </p>
          <p>
            <strong>Número:</strong>{" "}
            {empty(data?.info_poliza_caucion?.num_poliza)}
          </p>
          <p>
            <strong>Vigencia:</strong>{" "}
            {empty(data?.info_poliza_caucion?.fecha_vigencia_poliza)}
          </p>
        </div>

        {/* TECNICA */}
        <div style={cardStyle}>
          <div style={titleStyle}>Ficha Técnica</div>
          <p>
            <strong>Capacidad:</strong> {empty(data?.info_tecnica?.capacidad)}
          </p>
          <p>
            <strong>Pasajeros:</strong>{" "}
            {empty(data?.info_tecnica?.capacidad_pasajeros)}
          </p>
          <p>
            <strong>Sentados:</strong>{" "}
            {empty(data?.info_tecnica?.capacidad_pasajeros_sentados)}
          </p>
          <p>
            <strong>Ejes:</strong> {empty(data?.info_tecnica?.num_ejes)}
          </p>
          <p>
            <strong>Peso bruto:</strong> {empty(data?.info_tecnica?.peso_bruto)}
          </p>
        </div>
      </div>
    );
  };

  const revisionTMResult = (data: RevisionTM | "Error" | null) => {
    if (!data || data === "Error") {
      if (data === "Error") {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de revisión técnico mecánica
          </p>
        );
      }
      return (
        <p style={{ color: "white" }}>
          No se encontró información de revisión técnico mecánica
        </p>
      );
    }

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.2)",
      borderRadius: "8px",
      padding: "12px",
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          maxHeight: "500px",
          overflow: "auto",
          padding: "10px",
          color: "white",
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Revisión Técnico Mecánica</h3>

        {data?.noRevision ? (
          <div style={cardStyle}>
            <p>
              <strong>No. Revisión:</strong> {data?.noRevision ?? "N/A"}
            </p>

            <p>
              <strong>Fecha revisión:</strong> {data?.fechaRevision ?? "N/A"}
            </p>

            <p>
              <strong>Fecha vencimiento:</strong>{" "}
              {data?.fechaVencimiento ?? "N/A"}
            </p>

            <p>
              <strong>CDA:</strong> {data?.cda ?? "No disponible"}
            </p>

            <p>
              <strong>Requiere RTM:</strong>{" "}
              {data?.reqrtm === true
                ? "Sí"
                : data?.reqrtm === false
                ? "No"
                : "N/A"}
            </p>

            <p>
              <strong>Válido:</strong>{" "}
              {data?.valido === true || data?.valido === "SI"
                ? "Sí"
                : data?.valido === false || data?.valido === "NO"
                ? "No"
                : "N/A"}
            </p>

            <p>
              <strong>Vigente:</strong>{" "}
              {data?.vigente === true
                ? "Sí"
                : data?.vigente === false
                ? "No"
                : "N/A"}
            </p>
          </div>
        ) : (
          <div style={cardStyle}>
            <p>No se encontró información de revisión técnico mecánica</p>
          </div>
        )}
      </div>
    );
  };

  const simitResult = (data: Simit | "Error" | null) => {
    if (!data || data === "Error") {
      return <p style={{ color: "white" }}>No se encontró información SIMIT</p>;
    }

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const subCardStyle = {
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px",
      padding: "10px",
      marginTop: "10px",
      background: "rgba(255,255,255,0.02)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string | number | null) =>
      v !== null && v !== undefined && `${v}`.trim() !== ""
        ? v
        : "Sin información";

    const money = (n?: number) =>
      typeof n === "number"
        ? n.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
            maximumFractionDigits: 0,
          })
        : "$0";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información SIMIT</h3>

        {/* RESUMEN */}
        <div style={cardStyle}>
          <div style={titleStyle}>Resumen General</div>

          <p>
            <strong>Documento:</strong> {empty(data?.numero_documento)}
          </p>
          <p>
            <strong>Paz y salvo:</strong> {data?.paz_salvo ? "Sí" : "No"}
          </p>
          <p>
            <strong>Cantidad multas:</strong> {empty(data?.cantidad_multas)}
          </p>
          <p>
            <strong>Total multas:</strong> {money(data?.total_multas)}
          </p>
          <p>
            <strong>Total por pagar:</strong> {money(data?.total_pagar)}
          </p>
          <p>
            <strong>Acuerdos por pagar:</strong>{" "}
            {money(data?.total_acuardos_por_pagar)}
          </p>
        </div>

        {/* MULTAS */}
        <div style={cardStyle}>
          <div style={titleStyle}>Multas</div>

          {data?.multas?.length ? (
            data.multas.map((multa, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Multa #{i + 1}</strong>
                </p>

                <p>
                  <strong>Número comparendo:</strong>{" "}
                  {empty(multa?.numero_comparendo)}
                </p>
                <p>
                  <strong>Consecutivo:</strong>{" "}
                  {empty(multa?.consecutivo_comparendo)}
                </p>
                <p>
                  <strong>Placa:</strong> {empty(multa?.placa)}
                </p>
                <p>
                  <strong>Departamento:</strong> {empty(multa?.departamento)}
                </p>
                <p>
                  <strong>Organismo tránsito:</strong>{" "}
                  {empty(multa?.organismo_transito)}
                </p>
                <p>
                  <strong>Estado:</strong> {empty(multa?.estado)}
                </p>
                <p>
                  <strong>Fecha comparendo:</strong>{" "}
                  {empty(multa?.fecha_comparendo)}
                </p>
                <p>
                  <strong>Fecha notificación:</strong>{" "}
                  {empty(multa?.fecha_notificacion)}
                </p>
                <p>
                  <strong>Comparendo:</strong> {multa?.comparendo ? "Sí" : "No"}
                </p>
                <p>
                  <strong>Electrónico:</strong>{" "}
                  {multa?.comparendo_electronico ? "Sí" : "No"}
                </p>

                <p>
                  <strong>Valor multa:</strong> {money(multa?.valor_multa)}
                </p>
                <p>
                  <strong>Interés:</strong> {money(multa?.valor_interes)}
                </p>
                <p>
                  <strong>Descuento:</strong> {money(multa?.valor_descuento)}
                </p>
                <p>
                  <strong>Total pagar:</strong> {money(multa?.total_pagar)}
                </p>

                {/* INFRACTOR */}
                <div style={subCardStyle}>
                  <p>
                    <strong>Infractor</strong>
                  </p>
                  <p>
                    <strong>Nombre:</strong>{" "}
                    {`${empty(multa?.infractor?.nombres)} ${empty(
                      multa?.infractor?.apellidos
                    )}`}
                  </p>
                  <p>
                    <strong>Documento:</strong>{" "}
                    {empty(multa?.infractor?.documento)}
                  </p>
                  <p>
                    <strong>Tipo:</strong>{" "}
                    {empty(multa?.infractor?.tipo_documento)}
                  </p>
                </div>

                {/* INFRACCIONES */}
                <div style={subCardStyle}>
                  <p>
                    <strong>Infracciones</strong>
                  </p>

                  {multa?.infraciones?.length ? (
                    multa.infraciones.map((inf, x) => (
                      <div key={x} style={{ marginBottom: "8px" }}>
                        <p>
                          <strong>Código:</strong> {empty(inf?.codigo)}
                        </p>
                        <p>
                          <strong>Descripción:</strong>{" "}
                          {empty(inf?.descripcion)}
                        </p>
                        <p>
                          <strong>Valor:</strong> {money(inf?.valor)}
                        </p>
                      </div>
                    ))
                  ) : (
                    <p>No se encontraron infracciones asociadas</p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p>No se encontraron multas registradas</p>
          )}
        </div>

        {/* CURSOS */}
        <div style={cardStyle}>
          <div style={titleStyle}>Cursos</div>

          {data?.cursos?.length ? (
            data.cursos.map((curso, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Curso #{i + 1}</strong>
                </p>

                <p>
                  <strong>Centro instrucción:</strong>{" "}
                  {empty(curso?.centro_intruccion)}
                </p>
                <p>
                  <strong>Certificado:</strong> {empty(curso?.certificado)}
                </p>
                <p>
                  <strong>Ciudad:</strong> {empty(curso?.cuidad)}
                </p>
                <p>
                  <strong>Estado:</strong> {empty(curso?.estado)}
                </p>
                <p>
                  <strong>Fecha curso:</strong> {empty(curso?.fecha_curso)}
                </p>
                <p>
                  <strong>Fecha reporte:</strong> {empty(curso?.fecha_reporte)}
                </p>
                <p>
                  <strong>Fecha comparendo:</strong>{" "}
                  {empty(curso?.fecha_comparendo)}
                </p>
                <p>
                  <strong>Número multa:</strong> {empty(curso?.numero_multa)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontraron cursos registrados</p>
          )}
        </div>

        {/* ACUERDOS */}
        <div style={cardStyle}>
          <div style={titleStyle}>Acuerdos de Pago</div>

          <p>
            <strong>Cantidad:</strong> {empty(data?.acuerdos_pagar)}
          </p>

          {data?.acuerdos_pagos?.length ? (
            data.acuerdos_pagos.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                  {JSON.stringify(item, null, 2)}
                </pre>
              </div>
            ))
          ) : (
            <p>No se encontraron acuerdos de pago</p>
          )}
        </div>
      </div>
    );
  };
  const simurResult = (data: Simur[] | Simur | "Error" | null) => {
    if (!data || data === "Error") {
      return <p style={{ color: "white" }}>No se encontró información SIMUR</p>;
    }

    const registros = Array.isArray(data) ? data : [data];

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const subCardStyle = {
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px",
      padding: "10px",
      marginTop: "10px",
      background: "rgba(255,255,255,0.02)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string | number | null) =>
      v !== null && v !== undefined && `${v}`.trim() !== ""
        ? v
        : "Sin información";

    const money = (n?: number) =>
      typeof n === "number"
        ? n.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
            maximumFractionDigits: 0,
          })
        : "$0";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información SIMUR</h3>

        {/* RESUMEN */}
        <div style={cardStyle}>
          <div style={titleStyle}>Resumen</div>

          <p>
            <strong>Total registros:</strong> {registros.length}
          </p>

          <p>
            <strong>Comparendos con saldo:</strong>{" "}
            {
              registros.filter(
                (item) => typeof item?.Saldo === "number" && item.Saldo > 0
              ).length
            }
          </p>
        </div>

        {/* REGISTROS */}
        <div style={cardStyle}>
          <div style={titleStyle}>Comparendos</div>

          {registros.length ? (
            registros.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Registro #{i + 1}</strong>
                </p>

                <p>
                  <strong>No Comparendo:</strong>{" "}
                  {empty(item?.["No Comparendo"])}
                </p>

                <p>
                  <strong>Estado:</strong> {empty(item?.["Estado comparendo"])}
                </p>

                <p>
                  <strong>Fecha infracción:</strong>{" "}
                  {empty(item?.["Fecha Infraccion"])}
                </p>

                <p>
                  <strong>Infractor:</strong> {empty(item?.Infractor)}
                </p>

                <p>
                  <strong>Placa:</strong> {empty(item?.Placa)}
                </p>

                <p>
                  <strong>Tipo:</strong> {empty(item?.Tipo)}
                </p>

                <p>
                  <strong>Saldo:</strong> {money(item?.Saldo)}
                </p>

                <p>
                  <strong>Intereses:</strong> {money(item?.Intereses)}
                </p>

                <p>
                  <strong>Total saldo + intereses:</strong>{" "}
                  {money(item?.["Total saldo + intereses"])}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontraron comparendos registrados</p>
          )}
        </div>
      </div>
    );
  };
  const soatResult = (data: Soat | "Error" | null) => {
    if (!data || data === "Error") {
      return <p style={{ color: "white" }}>No se encontró información SOAT</p>;
    }

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string | null) =>
      v && v.trim() !== "" ? v : "Sin información";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información SOAT</h3>

        <div style={cardStyle}>
          <div style={titleStyle}>Detalle</div>

          <p>
            <strong>No. SOAT:</strong> {empty(data?.noSoat)}
          </p>

          <p>
            <strong>Fecha expedición:</strong> {empty(data?.fechaExpedicion)}
          </p>

          <p>
            <strong>Fecha inicio:</strong> {empty(data?.fechaInicio)}
          </p>

          <p>
            <strong>Fecha vencimiento:</strong> {empty(data?.fechaVencimiento)}
          </p>

          <p>
            <strong>Válido:</strong>{" "}
            {data?.valido === true
              ? "Sí"
              : data?.valido === false
              ? "No"
              : "Sin información"}
          </p>

          <p>
            <strong>Vigente:</strong>{" "}
            {data?.vigente === true
              ? "Sí"
              : data?.vigente === false
              ? "No"
              : "Sin información"}
          </p>
        </div>
      </div>
    );
  };

  const vusResult = (data: VUSInmov[] | "Error" | null) => {
    if (!data || data === "Error" || data.length === 0) {
      if (data === "Error") {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información asociada
          </p>
        );
      }
      return <p style={{ color: "white" }}>No se encontró información</p>;
    }

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <p style={{ color: "white" }}>{data.toString()}</p>
      </div>
    );
  };

  const vehiculoResult = (data: VehiculoResult | "Error" | null) => {
    if (!data || data === "Error") {
      return (
        <p style={{ color: "white" }}>
          No se encontró información del vehículo
        </p>
      );
    }

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string | null) =>
      v && v.trim() !== "" ? v : "Sin información";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información del Vehículo</h3>

        {/* DATOS PRINCIPALES */}
        <div style={cardStyle}>
          <div style={titleStyle}>Datos Generales</div>

          <p>
            <strong>Placa:</strong> {empty(data?.placa)}
          </p>

          <p>
            <strong>Marca:</strong> {empty(data?.marca)}
          </p>

          <p>
            <strong>Línea:</strong> {empty(data?.linea)}
          </p>

          <p>
            <strong>Modelo:</strong> {empty(data?.modelo)}
          </p>

          <p>
            <strong>Clase:</strong> {empty(data?.clase)}
          </p>

          <p>
            <strong>Color:</strong> {empty(data?.color)}
          </p>

          <p>
            <strong>Servicio:</strong> {empty(data?.tipo_servicio)}
          </p>
        </div>

        {/* REGISTRO */}
        <div style={cardStyle}>
          <div style={titleStyle}>Registro</div>

          <p>
            <strong>Licencia:</strong> {empty(data?.licencia)}
          </p>

          <p>
            <strong>Fecha matrícula:</strong> {empty(data?.fmatri)}
          </p>

          <p>
            <strong>Autoridad tránsito:</strong>{" "}
            {empty(data?.autoridad_de_transito)}
          </p>
        </div>

        {/* ESTADO */}
        <div style={cardStyle}>
          <div style={titleStyle}>Estado</div>

          <p>
            <strong>Estado:</strong> {empty(data?.estado)}
          </p>

          <p>
            <strong>Válido:</strong>{" "}
            {data?.valido === true
              ? "Sí"
              : data?.valido === false
              ? "No"
              : "Sin información"}
          </p>
        </div>
      </div>
    );
  };

  const contraloriaResult = (data: any | "Error" | null) => {
    if (!data || data === "Error") {
      if (data === "Error") {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de Contraloria
          </p>
        );
      }
      return (
        <p style={{ color: "white" }}>
          No se encontró información de Contraloria
        </p>
      );
    }

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <p style={{ color: "white" }}>{data.toString()}</p>
      </div>
    );
  };
  const contaduriaResult = (
    data: ContaduriaData[] | ContaduriaData | "Error" | null | boolean
  ) => {
    if (!data || data === "Error") {
      if (data === "Error") {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de Contaduría
          </p>
        );
      }
      return (
        <p style={{ color: "white" }}>
          No se encontró información de Contaduría
        </p>
      );
    }

    if (typeof data === "boolean") {
      if (data) {
        return (
          <p style={{ color: "white" }}>Revisar detalle en Contaduria Data</p>
        );
      }
      return (
        <p style={{ color: "white" }}>
          No se encontró información de Contaduría
        </p>
      );
    }

    const registros = Array.isArray(data) ? data : [data];

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const subCardStyle = {
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px",
      padding: "10px",
      marginTop: "10px",
      background: "rgba(255,255,255,0.02)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string | null) =>
      v && v.trim() !== "" ? v : "Sin información";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información Contaduría</h3>

        {/* RESUMEN */}
        <div style={cardStyle}>
          <div style={titleStyle}>Resumen</div>

          <p>
            <strong>Total registros:</strong> {registros.length}
          </p>

          <p>
            <strong>Registros activos:</strong>{" "}
            {
              registros.filter((x) => x?.estado?.toLowerCase() === "activo")
                .length
            }
          </p>
        </div>

        {/* REGISTROS */}
        <div style={cardStyle}>
          <div style={titleStyle}>Detalle</div>

          {registros.length ? (
            registros.map((item, i) => (
              <div key={i} style={subCardStyle}>
                <p>
                  <strong>Registro #{i + 1}</strong>
                </p>

                <p>
                  <strong>Entidad reportante:</strong>{" "}
                  {empty(item?.entidad_reportante)}
                </p>

                <p>
                  <strong>Estado:</strong> {empty(item?.estado)}
                </p>

                <p>
                  <strong>Fecha corte:</strong> {empty(item?.fecha_corte)}
                </p>

                <p>
                  <strong>Nombre reportado:</strong>{" "}
                  {empty(item?.nombre_reportado)}
                </p>

                <p>
                  <strong>Número obligación:</strong>{" "}
                  {empty(item?.numero_obligacion)}
                </p>
              </div>
            ))
          ) : (
            <p>No se encontraron registros</p>
          )}
        </div>
      </div>
    );
  };

  const defuncionesResult = (
    data: DefuncionesRegistraduria | "Error" | null
  ) => {
    if (!data || data === "Error") {
      return (
        <p style={{ color: "white" }}>
          No se encontró información de defunciones
        </p>
      );
    }

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string | number | null) =>
      v !== null && v !== undefined && `${v}`.trim() !== ""
        ? v
        : "Sin información";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información Defunciones</h3>

        {/* DETALLE */}
        <div style={cardStyle}>
          <div style={titleStyle}>Detalle</div>

          <p>
            <strong>Documento:</strong> {empty(data?.doc)}
          </p>

          <p>
            <strong>Fecha:</strong> {empty(data?.date)}
          </p>

          <p>
            <strong>Validez:</strong> {empty(data?.validity)}
          </p>
        </div>

        {/* ESTADO */}
        <div style={cardStyle}>
          <div style={titleStyle}>Estado</div>

          <p>
            <strong>Registro encontrado:</strong> {data ? "Sí" : "No"}
          </p>

          <p>
            <strong>Resultado:</strong>{" "}
            {data?.validity ? "Existe información asociada" : "Sin información"}
          </p>
        </div>
      </div>
    );
  };

  const delitosSexualesResult = (data: any | "Error" | null) => {
    if (!data || data === "Error") {
      if (data === "Error") {
        return (
          <p style={{ color: "red" }}>
            Hubo un error obteniendo información de la fuente
          </p>
        );
      }
      return (
        <p style={{ color: "white" }}>
          No se encontró información en la fuente
        </p>
      );
    }

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <p style={{ color: "white" }}>{data.toString()}</p>
      </div>
    );
  };

  /* =========================================================
   HELPERS COMPARTIDOS
========================================================= */

  const containerStyle = {
    display: "flex",
    flexDirection: "column" as const,
    gap: "12px",
    maxHeight: "650px",
    overflow: "auto" as const,
    padding: "10px",
    color: "white",
  };

  const cardStyle = {
    border: "1px solid rgba(255,255,255,0.15)",
    borderRadius: "10px",
    padding: "14px",
    background: "rgba(255,255,255,0.03)",
  };

  const subCardStyle = {
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "8px",
    padding: "10px",
    marginTop: "10px",
    background: "rgba(255,255,255,0.02)",
  };

  const titleStyle = {
    fontWeight: 700,
    fontSize: "15px",
    marginBottom: "10px",
  };

  const noInfo =
    "No tiene información en la fuente basado en los parámetros de consulta";

  const stringifySafe = (value: any): string => {
    try {
      if (value === null || value === undefined) return noInfo;
      if (typeof value === "string") return value;
      if (typeof value === "number" || typeof value === "boolean")
        return String(value);

      if (Array.isArray(value)) {
        if (!value.length) return noInfo;

        return value
          .map((item) =>
            typeof item === "object"
              ? JSON.stringify(item, null, 2)
              : String(item)
          )
          .join("\n\n");
      }

      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }

      return String(value);
    } catch {
      return "No fue posible procesar la información";
    }
  };

  const renderUnknownSource = (title: string, value: any) => {
    if (value === undefined || value === null || value === false) {
      return <p style={{ color: "white" }}>{noInfo}</p>;
    }

    if (value === "Error") {
      return <p style={{ color: "white" }}>No se encontró información</p>;
    }

    if (typeof value === "string") {
      return (
        <div style={containerStyle}>
          <h3 style={{ fontWeight: 700 }}>{title}</h3>

          <div style={cardStyle}>
            <pre
              style={{
                whiteSpace: "pre-wrap",
                margin: 0,
                fontFamily: "inherit",
              }}
            >
              {value}
            </pre>
          </div>
        </div>
      );
    }

    if (typeof value === "boolean") {
      return (
        <p style={{ color: "white" }}>
          {value ? "Existe información asociada" : noInfo}
        </p>
      );
    }

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>{title}</h3>

        <div style={cardStyle}>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              margin: 0,
              fontFamily: "inherit",
            }}
          >
            {stringifySafe(value)}
          </pre>
        </div>
      </div>
    );
  };

  /* =========================================================
   1. IADB
========================================================= */

  const iadbResult = (data?: any) => {
    return renderUnknownSource("IADB", data);
  };

  /* =========================================================
   2. INPEC
========================================================= */

  const inpecResult = (data?: any) => {
    return renderUnknownSource("INPEC", data);
  };

  /* =========================================================
   3. INSOLVENCIAS
========================================================= */

  const insolvenciasResult = (data?: any[]) => {
    return renderUnknownSource("Insolvencias", data);
  };

  /* =========================================================
   4. INTERPOL
========================================================= */

  const interpolResult = (data?: boolean | any[] | string) => {
    return renderUnknownSource("Interpol", data);
  };

  /* =========================================================
   5. JUZGADOS
========================================================= */

  const juzgadosResult = (data?: any[]) => {
    return renderUnknownSource("Juzgados", data);
  };

  /* =========================================================
   6. LISTA ONU
========================================================= */

  const listaOnuResult = (data?: boolean | any[] | string) => {
    return renderUnknownSource("Lista ONU", data);
  };

  /* =========================================================
   7. OFAC
========================================================= */

  const ofacResult = (data?: boolean | any[] | string) => {
    return renderUnknownSource("OFAC", data);
  };

  /* =========================================================
   8. OFAC NOMBRE
========================================================= */

  const ofacNombreResult = (data?: any) => {
    return renderUnknownSource("OFAC Nombre", data);
  };

  const europolResult = (data?: any[]) => {
    return renderUnknownSource("Europol", data);
  };

  const pacoOnlineResult = (data?: any[]) => {
    return renderUnknownSource("Paco Online", data);
  };

  const policiaResult = (data?: boolean | string) => {
    return renderUnknownSource("Policia", data);
  };

  const peps = (data?: any[]) => {
    return renderUnknownSource("PEPS", data);
  };

  const rutResult = (data?: string) => {
    return renderUnknownSource("RUT", data);
  };

  const rutEstado = (data?: string) => {
    return renderUnknownSource("RUT Estado", data);
  };

  const listaBancoMundialResult = (
    data: ListaBancoMundial | "Error" | null
  ) => {
    if (!data || data === "Error") {
      return (
        <p style={{ color: "white" }}>
          No se encontró información de Lista Banco Mundial
        </p>
      );
    }

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Lista Banco Mundial</h3>

        <div style={cardStyle}>
          <div style={titleStyle}>Debarred Firms / Individuals</div>

          <pre
            style={{
              whiteSpace: "pre-wrap",
              margin: 0,
              fontFamily: "inherit",
            }}
          >
            {stringifySafe(data?.debarred_firms_individuals)}
          </pre>
        </div>

        <div style={cardStyle}>
          <div style={titleStyle}>Other Sanctions</div>

          <pre
            style={{
              whiteSpace: "pre-wrap",
              margin: 0,
              fontFamily: "inherit",
            }}
          >
            {stringifySafe(data?.others_sanctions)}
          </pre>
        </div>
      </div>
    );
  };
  const offshoreLeaksResult = (data: OffshoreLeaks | "Error" | null) => {
    if (!data || data === "Error") {
      return (
        <p style={{ color: "white" }}>
          No se encontró información Offshore Leaks
        </p>
      );
    }

    const leaks = [
      "Bahamas Leaks",
      "Offshore Leaks",
      "Panama Papers",
      "Pandora Papers",
      "Paradise Papers",
    ] as const;

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Offshore Leaks</h3>

        {leaks.map((key, i) => (
          <div key={i} style={cardStyle}>
            <div style={titleStyle}>{key}</div>

            <pre
              style={{
                whiteSpace: "pre-wrap",
                margin: 0,
                fontFamily: "inherit",
              }}
            >
              {stringifySafe(data?.[key])}
            </pre>
          </div>
        ))}
      </div>
    );
  };
  const registraduriaCertificadoResult = (
    data: RegistraduriaCertificado | "Error" | null
  ) => {
    const empty = (v?: any) =>
      v !== null && v !== undefined && `${v}`.trim() !== ""
        ? v
        : "Sin información";

    const stringifySafe = (value: any): string => {
      try {
        if (value === null || value === undefined) return noInfo;

        if (
          typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean"
        ) {
          return String(value);
        }

        if (Array.isArray(value)) {
          if (!value.length) return noInfo;

          return value
            .map((item) =>
              typeof item === "object"
                ? JSON.stringify(item, null, 2)
                : String(item)
            )
            .join("\n\n");
        }

        if (typeof value === "object") {
          return JSON.stringify(value, null, 2);
        }

        return String(value);
      } catch {
        return "No fue posible procesar la información";
      }
    };
    if (!data || data === "Error") {
      return (
        <p style={{ color: "white" }}>
          No se encontró información de Registraduría
        </p>
      );
    }

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Certificado Registraduría</h3>

        <div style={cardStyle}>
          <div style={titleStyle}>Información General</div>

          <p>
            <strong>Cédula:</strong> {empty(data?.cedula)}
          </p>

          <p>
            <strong>Nombre:</strong> {empty(data?.nombre)}
          </p>

          <p>
            <strong>Estado:</strong> {empty(data?.estado)}
          </p>

          <p>
            <strong>Fecha expedición:</strong> {empty(data?.fecha_exp)}
          </p>

          <p>
            <strong>Lugar expedición:</strong> {empty(data?.lugar_exp)}
          </p>
        </div>
      </div>
    );
  };
  const ruafResult = (data: Ruaf | "Error" | null) => {
    if (!data || data === "Error") {
      return <p style={{ color: "white" }}>No se encontró información RUAF</p>;
    }

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "700px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const subCardStyle = {
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "8px",
      padding: "10px",
      marginTop: "10px",
      background: "rgba(255,255,255,0.02)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: any) =>
      v !== null && v !== undefined && `${v}`.trim() !== ""
        ? v
        : "Sin información";

    const stringifySafe = (value: any) => {
      try {
        if (value === null || value === undefined) {
          return "Sin información";
        }

        if (
          typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean"
        ) {
          return String(value);
        }

        return JSON.stringify(value, null, 2);
      } catch {
        return "No fue posible procesar la información";
      }
    };

    const renderList = (title: string, list?: any[]) => (
      <div style={cardStyle}>
        <div style={titleStyle}>{title}</div>

        {list?.length ? (
          list.map((item, i) => (
            <div key={i} style={subCardStyle}>
              {Object.entries(item || {}).map(([k, v], idx) => (
                <p key={idx}>
                  <strong>{k}:</strong> {empty(v)}
                </p>
              ))}
            </div>
          ))
        ) : (
          <p>No se encontró información asociada</p>
        )}
      </div>
    );

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información RUAF</h3>

        {/* BASICO */}
        {renderList("Datos Básicos", data?.Basico)}

        {/* SALUD */}
        {renderList("Salud", data?.Salud)}

        {/* ARL */}
        {renderList("ARL", data?.ARL)}

        {/* PENSIONES */}
        {renderList("Pensiones", data?.Pensiones)}

        {/* PENSIONADO */}
        {renderList("Pensionado", data?.Pensionado)}

        {/* PROGRAMAS */}
        {renderList(
          "Programas de Asistencia Social",
          data?.["Programas de Asistencia Social"]
        )}

        {/* CAJA DE COMPENSACIÓN */}
        <div style={cardStyle}>
          <div style={titleStyle}>Caja de compensación</div>

          <pre
            style={{
              whiteSpace: "pre-wrap",
              margin: 0,
              fontFamily: "inherit",
            }}
          >
            {stringifySafe(data?.["Caja de compensación"])}
          </pre>
        </div>

        {/* CESANTÍAS */}
        <div style={cardStyle}>
          <div style={titleStyle}>Cesantías</div>

          <pre
            style={{
              whiteSpace: "pre-wrap",
              margin: 0,
              fontFamily: "inherit",
            }}
          >
            {stringifySafe(data?.Cesantías)}
          </pre>
        </div>
      </div>
    );
  };

  const sisbenResult = (data: Sisben | "Error" | null) => {
    if (!data || data === "Error") {
      return (
        <p style={{ color: "white" }}>No se encontró información SISBÉN</p>
      );
    }

    const containerStyle = {
      display: "flex",
      flexDirection: "column" as const,
      gap: "12px",
      maxHeight: "650px",
      overflow: "auto" as const,
      padding: "10px",
      color: "white",
    };

    const cardStyle = {
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: "10px",
      padding: "14px",
      background: "rgba(255,255,255,0.03)",
    };

    const titleStyle = {
      fontWeight: 700,
      fontSize: "15px",
      marginBottom: "10px",
    };

    const empty = (v?: string | null) =>
      v && v.trim() !== "" ? v : "Sin información";

    return (
      <div style={containerStyle}>
        <h3 style={{ fontWeight: 700 }}>Información SISBÉN</h3>

        {/* DATOS PERSONALES */}
        <div style={cardStyle}>
          <div style={titleStyle}>Datos Personales</div>

          <p>
            <strong>Nombre:</strong> {empty(data?.Nombre)}
          </p>

          <p>
            <strong>Apellido:</strong> {empty(data?.Apellido)}
          </p>

          <p>
            <strong>Estado:</strong> {empty(data?.Estado)}
          </p>
        </div>

        {/* CLASIFICACIÓN */}
        <div style={cardStyle}>
          <div style={titleStyle}>Clasificación</div>

          <p>
            <strong>Grupo:</strong> {empty(data?.Grupo)}
          </p>

          <p>
            <strong>Tipo de grupo:</strong> {empty(data?.["Tipo de grupo"])}
          </p>

          <p>
            <strong>Ficha:</strong> {empty(data?.Ficha)}
          </p>
        </div>

        {/* UBICACIÓN */}
        <div style={cardStyle}>
          <div style={titleStyle}>Ubicación</div>

          <p>
            <strong>Departamento:</strong> {empty(data?.Departamento)}
          </p>

          <p>
            <strong>Municipio:</strong> {empty(data?.Municipio)}
          </p>
        </div>

        {/* ACTUALIZACIÓN */}
        <div style={cardStyle}>
          <div style={titleStyle}>Actualización</div>

          <p>
            <strong>Fecha actualización:</strong>{" "}
            {empty(data?.["Actualizacion Ciudadano"])}
          </p>
        </div>
      </div>
    );
  };

  const showDataResult = (listName: string, resultData?: any) => {
    switch (listName) {
      case "rndc":
        return rndcResult(resultData);
      case "rama_unificada":
        return ramaUnificadaResult(resultData);
      case "rama":
        return ramaResult(resultData);
      case "runt_app":
        return runtAppResult(resultData);
      case "garantias_mobiliarias":
        return garantiasMobiliariasResult(resultData);
      case "contaduria":
      case "contaduria_data":
        return contaduriaResult(resultData);
      case "contaduria_hallazgo":
        return contaduriaHallazgoResult(resultData);
      case "contaduria_pdf":
        return contaduriaPdfResult(resultData);
      case "contraloria":
        return contraloriaResult(resultData);
      case "defunciones_registraduria":
        return defuncionesResult(resultData);
      case "delitos_sexuales":
        return delitosSexualesResult(resultData);
      case "europol":
        return europolResult(resultData);
      case "libretamilitar":
        return libretaMilitarResult(resultData);
      case "lista_banco_mundial":
        return listaBancoMundialResult(resultData);
      case "sisconmp":
        return sisconmpResult(resultData);
      case "juzgados_tyba":
        return juzgadosTybaResult(resultData);
      case "iadb":
        return iadbResult(resultData);
      case "inpec":
        return inpecResult(resultData);
      case "insolvencias":
        return insolvenciasResult(resultData);
      case "interpol":
        return interpolResult(resultData);
      case "juzgados":
        return juzgadosResult(resultData);
      case "lista_onu":
        return listaOnuResult(resultData);
      case "ofac":
        return ofacResult(resultData);
      case "ofac_nombre":
        return ofacNombreResult(resultData);
      case "offshoreleaks":
        return offshoreLeaksResult(resultData);
      case "accidentalidad_bog":
        return accidentalidadBogResult(resultData);
      case "impuesto_bogota":
        return impuestosVehiculoResult(resultData);
      case "impuestos_antioquia":
        return impuestosVehiculoResult(resultData);
      case "impuestos_atlantico":
        return impuestosVehiculoResult(resultData);
      case "impuestos_bolivar":
        return impuestosVehiculoResult(resultData);
      case "impuestos_cauca":
        return impuestosVehiculoResult(resultData);
      case "impuestos_cundinamarca":
        return impuestosVehiculoResult(resultData);
      case "impuestos_magdalena":
        return impuestosVehiculoResult(resultData);
      case "impuestos_nte_santander":
        return impuestosVehiculoResult(resultData);
      case "impuestos_risaralda":
        return impuestosVehiculoResult(resultData);
      case "impuestos_santander":
        return impuestosVehiculoResult(resultData);
      case "impuestos_valle":
        return impuestosVehiculoResult(resultData);
      case "matricula":
        return matriculaEstadoResult(resultData);
      case "omisiones_vehiculos":
        return omisionesVehiculosResult(resultData);
      case "paco_online":
        return pacoOnlineResult(resultData);
      case "peps":
        return peps(resultData);
      case "policia":
        return policiaResult(resultData);
      case "registraduria_certificado":
        return registraduriaCertificadoResult(resultData);
      case "revision":
        return revisionTMResult(resultData);
      case "ruaf":
        return ruafResult(resultData);
      case "runt":
        return runtResult(resultData);
      case "rut":
        return rutResult(resultData);
      case "rut_estado":
        return rutEstado(resultData);
      case "simit":
        return simitResult(resultData);
      case "simur":
        return simurResult(resultData);
      case "sisben":
        return sisbenResult(resultData);
      case "soat":
        return soatResult(resultData);
      case "vus_inmov_bog":
        return vusResult(resultData);
      case "vehiculo":
        return vehiculoResult(resultData);
      default:
        return <></>;
    }
  };

  const hasAlert = (
    listName: string,
    hallazgosAltos: Hallazgo[],
    hallazgosMedios: Hallazgo[]
  ) => {
    const hasAltos = hallazgosAltos.some(
      (hallazgo) => hallazgo.fuente === listName
    );
    const hasMedios = hallazgosMedios.some(
      (hallazgo) => hallazgo.fuente === listName
    );
    return hasAltos || hasMedios;
  };

  const listNameConvert = (listName: string) => {
    switch (listName) {
      case "ramajepms":
        return "Rama JEPMS";
      case "actividades_economicas":
        return "Actividades Económicas";
      case "categoria_matricula":
        return "Categoría de Matrícula";
      case "clase_identificacion":
        return "Clase de Identificación";
      case "codigo_camara":
        return "Código de Cámara";
      case "codigo_estado":
        return "Código de Estado";
      case "concordato":
        return "Concordato";
      case "defunciones_registraduria":
        return "Defunciones Registraduría";
      case "policia":
        return "Antecedentes policiales";
      case "rut":
        return "RUT";
      case "rut_estado":
        return "Estado del RUT";
      case "reputacional":
        return "Reputacional";
      case "garantias_mobiliarias":
        return "Garantías Mobiliarias";
      case "genero":
        return "Género";
      case "sena":
        return "Sena";
      case "rama_unificada_data":
        return "Rama Judicial Unificada";
      case "rama":
        return "Rama judicial";
      case "rama_unificada":
        return "Rama judicial unificada";
      case "contaduria":
        return "Contaduria";
      case "contaduria_data":
        return "Contaduria";
      case "contaduria_hallazgo":
        return "Contaduria Hallazgos";
      case "contaduria_pdf":
        return "Contaduria PDF";
      case "contraloria":
        return "Contraloría";
      case "europol":
        return "Europol";
      case "iadb":
        return "IADB";
      case "insolvencias":
        return "Insolvencias";
      case "interpol":
        return "Interpol";
      case "juzgados_tyba":
        return "Juzgados TYBA";
      case "libretamilitar":
        return "Libreta Limitar";
      case "lista_banco_mundial":
        return "Banco Mundial";
      case "lista_onu":
        return "ONU";
      case "nombre":
        return "Nombre";
      case "nombre-procuraduria":
        return "Nombre (Procuraduría)";
      case "ofac":
        return "OFAC";
      case "ofac_nombre":
        return "Nombre (OFAC)";
      case "offshoreleaks":
        return "Offshore Leaks";
      case "paco_online":
        return "PACO Online";
      case "peps":
        return "PEPS";
      case "peps_consolidado":
        return "PEPs Consolidados";
      case "peps_denom":
        return "Denominación PEPs";
      case "peps_version":
        return "Versión PEPs";
      case "procuraduria":
        return "Antecedentes Procuraduría";
      case "profesion":
        return "Profesión";
      case "proveedores_ficticios":
        return "Proveedores Ficticios";
      case "rndc":
        return "RNDC";
      case "rues":
        return "RUES";
      case "sirna":
        return "Registro nacional de abogados";
      case "runt":
        return "RUNT";
      case "runt_app":
        return "RUNT";
      case "simit":
        return "Comparendos SIMIT";
      case "simur":
        return "Comparendos Secretaría distrital";
      case "estado":
        return "Estado";
      case "estadoRM":
        return "Estado RM";
      case "identificacion":
        return "Identificación";
      case "matricula":
        return "Matrícula";
      case "municipio":
        return "Municipio";
      case "nit":
        return "NIT";
      case "nombre_camara":
        return "Nombre Cámara";
      case "organizacion_juridica":
        return "Organización Jurídica";
      case "propietario_o_establecimientos_agencias_sucursales":
        return "Propietario o Establecimientos/Agencias/Sucursales";
      case "radicaciones_sic":
        return "Radicaciones SIC";
      case "razon_social":
        return "Razón Social";
      case "registro_mercantil":
        return "Registro Mercantil";
      case "renovaciones_anteriores":
        return "Renovaciones Anteriores";
      case "representacion_legal":
        return "Representación Legal";
      case "representacion_legal_y_vinculos":
        return "Representación Legal y Vínculos";
      case "secop":
        return "SECOP";
      case "secop2":
        return "SECOP II";
      case "accidentalidad_bog":
        return "Accidentalidad Bogotá";
      case "impuesto_bogota":
        return "Impuestos Bogotá";
      case "impuestos_antioquia":
        return "Impuestos Antioquia";
      case "impuestos_atlantico":
        return "Impuestos Atlántico";
      case "impuestos_bolivar":
        return "Impuestos Bolívar";
      case "impuestos_cauca":
        return "Impuestos Cauca";
      case "impuestos_cundinamarca":
        return "Impuestos Cundinamarca";
      case "impuestos_magdalena":
        return "Impuestos Magdalena";
      case "impuestos_nte_santander":
        return "Impuestos Norte de Santander";
      case "impuestos_risaralda":
        return "Impuestos Risaralda";
      case "impuestos_santander":
        return "Impuestos Santander";
      case "impuestos_valle":
        return "Impuestos Valle del Cauca";
      case "omisiones_vehiculos":
        return "Omisiones Vehículos";
      case "delitos_sexuales":
        return "Delitos Sexuales";
      case "registraduria_certificado":
        return "Certificado Registraduria";
      case "rnmc":
        return "Registro Nacional Medidas Correctivas";
      case "ruaf":
        return "RUAF";
      case "sisconmp":
        return "Sistema de Información de Conductores que Transportan Mercancías Peligrosas";
      case "revision":
        return "Revisión Tecnomecánica";
      case "soat":
        return "SOAT";
      case "vehiculo":
        return "Información Vehículo";
      case "vus_inmov_bog":
        return "VUS Inmovilizaciones Bogotá";
      case "sisben":
        return "SISBEN";
      default:
        return listName;
    }
  };
  const getStatusName = (consResult: ConsultationResultDetail) => {
    if (consResult.status) {
      if (consResult.executingRetry) {
        return "Ejecutando reintento";
      }
      switch (consResult.status) {
        case "started":
          return "En proceso";
        case "finished":
          return "Terminado";
        default:
          return "En proceso";
      }
    } else {
      return "Error";
    }
  };

  const getIdentificationType = (identificationType: string) => {
    switch (identificationType) {
      case "CC":
        return "Cedula de ciudadanía";
      case "PP":
        return "Pasaporte";
      case "CE":
        return "Cedula de extranjeria";
      case "INT":
        return "Internacional";
      case "PPT":
        return "Permiso de permanencia";
      case "NIT":
        return "NIT";
      default:
        return "Cedula de ciudadanía";
    }
  };

  const { id } = useParams();
  useEffect(() => {
    if (!currentConsultationDetail && id) {
      dispatch(getConsultationDetail(id));
    }
  }, [id, currentConsultationDetail]);
  return (
    <LoadingOverlay
      active={detailLoading === "pending"}
      spinner={<ClipLoader color="white" size="150px" />}
    >
      <Modal
        isOpen={showHallazgosDetailModal}
        style={customStylesModalHallazgos}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setSelectedHallazgos([]);
          setShowHallazgosDetailModal(false);
        }}
      >
        {selectedHallazgos && (
          <div className="flex-col" style={{ padding: "10px" }}>
            <div
              className="text-large text-bold"
              style={{ textAlign: "center", fontSize: "18px" }}
            >
              Detalle de las alertas
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                margin: "10px 0",
                width: "100%",
                overflow: "auto",
              }}
            >
              <table style={{ marginTop: "10px", width: "100%" }}>
                <thead>
                  <th style={{ color: "black", fontWeight: 600 }}>Fuente</th>
                  <th style={{ color: "black", fontWeight: 600 }}>Hallazgo</th>
                  <th style={{ color: "black", fontWeight: 600 }}>
                    Descripción
                  </th>
                  <th style={{ color: "black", fontWeight: 600 }}>Código</th>
                  <th style={{ color: "black", fontWeight: 600 }}>Cantidad</th>
                </thead>
                <tbody style={{ overflow: "auto" }}>
                  {selectedHallazgos.map((hallazgo, index) => {
                    return (
                      <tr
                        key={index}
                        style={{ border: "1px solid rgba(0,0,0,0.2)" }}
                      >
                        <td
                          style={{
                            color: "black",
                            fontWeight: 500,
                            fontSize: "15px",
                            border: "1px solid rgba(0,0,0,0.2)",
                          }}
                        >
                          {listNameConvert(hallazgo.fuente)}
                        </td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: 500,
                            fontSize: "15px",
                            border: "1px solid rgba(0,0,0,0.2)",
                          }}
                        >
                          {hallazgo.hallazgo}
                        </td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: 500,
                            fontSize: "15px",
                            border: "1px solid rgba(0,0,0,0.2)",
                          }}
                        >
                          {hallazgo.descripcion}
                        </td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: 500,
                            fontSize: "15px",
                            border: "1px solid rgba(0,0,0,0.2)",
                          }}
                        >
                          {hallazgo.codigo}
                        </td>
                        <td
                          style={{
                            color: "black",
                            fontWeight: 500,
                            fontSize: "15px",
                            border: "1px solid rgba(0,0,0,0.2)",
                          }}
                        >
                          {hallazgo.cantidad}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div
              className="flex-row"
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <div
                onClick={(e) => {
                  e.preventDefault();
                  setShowHallazgosDetailModal(false);
                  setSelectedHallazgos([]);
                }}
                className="flex-col text-medium text-bold primary-color"
                style={{
                  background: "#1A617D",
                  width: "20%",
                  height: "30px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Cerrar
              </div>
            </div>
          </div>
        )}{" "}
      </Modal>
      <Modal
        isOpen={showVehicleDetailModal}
        style={customStylesModalVehicleDetail}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => setShowVehicleDetailModal(false)}
      >
        {currentConsultationDetail &&
          currentConsultationDetail.vehicleConsult && (
            <div className="flex-col" style={{ padding: "10px" }}>
              <div
                className="text-large text-bold"
                style={{ textAlign: "center", fontSize: "18px" }}
              >
                Detalle del vehiculo
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "10px 0",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "50%",
                    textAlign: "start",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <h5
                    style={{
                      color: "black",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    Información básica del vehículo
                  </h5>
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .placa && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Placa:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .fmatri && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Fecha matrícula:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .linea && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Linea:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .marca && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Marca:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .color && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Color:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .estado && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Estado:
                      </h5>
                    )}
                  <h5
                    style={{
                      color: "black",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    SOAT del vehículo
                  </h5>
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat.vigente !==
                      undefined && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Vigente:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat.noSoat && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Número de SOAT:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat
                      .fechaExpedicion && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Fecha de Expedición:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat
                      .fechaInicio && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Fecha de inicio:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat
                      .fechaVencimiento && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Fecha de vencimiento:
                      </h5>
                    )}
                  <h5
                    style={{
                      color: "black",
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    Revisión tecnomecánica
                  </h5>
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .vigente !== undefined && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Vigente
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .noRevision && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Número de Revisión:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .fechaRevision && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Fecha de Revisión:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .fechaVencimiento && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Fecha de vencimiento:
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .reqrtm !== undefined && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Requiere Revisión Tecnomecánica
                      </h5>
                    )}
                </div>{" "}
                <div
                  style={{
                    width: "50%",
                    textAlign: "start",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <h5
                    style={{
                      color: "black",
                      fontSize: "14px",
                      fontWeight: "500",
                      height: "16px",
                    }}
                  >
                    {" "}
                  </h5>
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .placa && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {
                          currentConsultationDetail.vehicleConsult.infoVehiculo
                            .placa
                        }
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .fmatri && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.infoVehiculo
                            .fmatri}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .linea && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.infoVehiculo
                            .linea}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .marca && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.infoVehiculo
                            .marca}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .color && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.infoVehiculo
                            .color}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.infoVehiculo
                      .estado && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.infoVehiculo
                            .estado}
                      </h5>
                    )}
                  <h5
                    style={{
                      color: "black",
                      fontSize: "14px",
                      fontWeight: "500",
                      height: "18px",
                    }}
                  >
                    {" "}
                  </h5>
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat.vigente !==
                      undefined && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                        currentConsultationDetail.vehicleConsult.soat.vigente
                          ? "Si"
                          : "No"}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat.noSoat && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.soat.noSoat}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat
                      .fechaExpedicion && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.soat
                            .fechaExpedicion}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat
                      .fechaInicio && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.soat
                            .fechaInicio}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.soat
                      .fechaVencimiento && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.soat
                            .fechaVencimiento}
                      </h5>
                    )}
                  <h5
                    style={{
                      color: "black",
                      fontSize: "14px",
                      fontWeight: "500",
                      height: "18px",
                    }}
                  >
                    {" "}
                  </h5>
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .vigente !== undefined && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                        currentConsultationDetail.vehicleConsult.tecnomecanica
                          .vigente
                          ? "Sí"
                          : "No"}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .noRevision && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult.tecnomecanica
                            .noRevision}
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .fechaRevision && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        {
                          currentConsultationDetail.vehicleConsult.tecnomecanica
                            .fechaRevision
                        }
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .fechaVencimiento && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        {
                          currentConsultationDetail.vehicleConsult.tecnomecanica
                            .fechaVencimiento
                        }
                      </h5>
                    )}
                  {currentConsultationDetail.vehicleConsult &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica &&
                    currentConsultationDetail.vehicleConsult.tecnomecanica
                      .reqrtm !== undefined && (
                      <h5
                        style={{
                          color: "black",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        {currentConsultationDetail.vehicleConsult &&
                        currentConsultationDetail.vehicleConsult.tecnomecanica
                          .reqrtm
                          ? "Sí"
                          : "No"}
                      </h5>
                    )}
                </div>
              </div>
              <div
                className="flex-row"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShowVehicleDetailModal(false);
                  }}
                  className="flex-col text-medium text-bold primary-color"
                  style={{
                    background: "#1A617D",
                    width: "20%",
                    height: "30px",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Cerrar
                </div>
              </div>
            </div>
          )}
      </Modal>
      {currentConsultationDetail && detailLoading === "resolved" ? (
        <div className="flex-col" style={{ overflow: "auto", width: "100%" }}>
          {!currentUrl.includes("hyperFlow") && (
            <div
              className="flex-row"
              style={{
                height: "5%",
                justifyContent: "end",
                alignItems: "center",
                marginRight: "5%",
              }}
            >
              <div
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(setCurrentConsultationDetail(null));
                  navigate("/services/manualLists/consultations");
                }}
                className="flex-row"
                style={{
                  alignItems: "center",
                  justifyContent: "space-evenly",
                }}
              >
                <LeftArrow style={{ marginRight: "15px" }} />
                <div className="text-bold text-xx-large primary-color">
                  Regresar a lista de consultas
                </div>
              </div>
            </div>
          )}
          <div className="flex-row" style={{ overflow: "auto", width: "100%" }}>
            <div
              className="flex-col"
              style={{
                width: "75%",
                justifyContent: "start",
                padding: "1%",
              }}
            >
              <div className="flex-row" style={{ width: "100%" }}>
                {currentConsultationDetail &&
                  (currentConsultationDetail.personConsult ||
                    currentConsultationDetail.vehicleConsult) && (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "8px",
                        alignItems: "center",
                        backgroundColor: "rgba(0,0,0,0.2)",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "8px 8px 0px 0px",
                          background: "rgba(0,0,0,0.2)",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "30px",
                        }}
                      >
                        <h6
                          style={{
                            color: "rgba(255,255,255,0.6)",
                            fontSize: "14px",
                            margin: "0px",
                          }}
                        >
                          Datos del consultado
                        </h6>
                      </div>
                      <div
                        style={{
                          width: "96%",
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "8px",
                          background: "rgba(0,0,0,0.2)",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "10px 0px",
                          padding: "10px 10px",
                        }}
                      >
                        {currentConsultationDetail &&
                          currentConsultationDetail.personConsult && (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-evenly",
                              }}
                            >
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "start",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {currentConsultationDetail.personConsult
                                  .name && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Nombre:
                                  </h5>
                                )}
                                {currentConsultationDetail.personConsult
                                  .identification && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Identificación
                                  </h5>
                                )}
                                {currentConsultationDetail.personConsult
                                  .identificationType && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Tipo de identificación
                                  </h5>
                                )}
                                {currentConsultationDetail.personConsult
                                  .fechaExpedicion && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Fecha de expedición identificación
                                  </h5>
                                )}
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "start",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {currentConsultationDetail.personConsult
                                  .name && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {
                                      currentConsultationDetail.personConsult
                                        .name
                                    }
                                  </h5>
                                )}
                                {currentConsultationDetail.personConsult
                                  .identification && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {
                                      currentConsultationDetail.personConsult
                                        .identification
                                    }
                                  </h5>
                                )}
                                {currentConsultationDetail.personConsult
                                  .identificationType && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {getIdentificationType(
                                      currentConsultationDetail.personConsult
                                        .identificationType
                                    )}
                                  </h5>
                                )}
                                {currentConsultationDetail.personConsult
                                  .fechaExpedicion && (
                                  <h5
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {
                                      currentConsultationDetail.personConsult
                                        .fechaExpedicion
                                    }
                                  </h5>
                                )}
                              </div>
                            </div>
                          )}
                        {currentConsultationDetail.vehicleConsult &&
                          currentConsultationDetail.vehicleConsult
                            .infoVehiculo && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "start",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <h5
                                  style={{
                                    color: "white",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                  }}
                                >
                                  Información del propietario
                                </h5>
                                {currentConsultationDetail.vehicleConsult &&
                                  currentConsultationDetail.vehicleConsult
                                    .ownerIdentification && (
                                    <h5
                                      style={{
                                        color: "white",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Identificación del propietario:
                                    </h5>
                                  )}
                                {currentConsultationDetail.vehicleConsult &&
                                  currentConsultationDetail.vehicleConsult
                                    .ownerIdentificationType && (
                                    <h5
                                      style={{
                                        color: "white",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Tipo de identificación del propietario:
                                    </h5>
                                  )}
                                {currentConsultationDetail.vehicleConsult &&
                                  currentConsultationDetail.vehicleConsult
                                    .infoVehiculo.placa && (
                                    <h5
                                      style={{
                                        color: "white",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Placa:
                                    </h5>
                                  )}
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "start",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <h5
                                  style={{
                                    color: "white",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    height: "14px",
                                  }}
                                >
                                  {" "}
                                </h5>
                                {currentConsultationDetail.vehicleConsult &&
                                  currentConsultationDetail.vehicleConsult
                                    .ownerIdentification && (
                                    <h5
                                      style={{
                                        color: "white",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {
                                        currentConsultationDetail.vehicleConsult
                                          .ownerIdentification
                                      }
                                    </h5>
                                  )}
                                {currentConsultationDetail.vehicleConsult &&
                                  currentConsultationDetail.vehicleConsult
                                    .ownerIdentificationType && (
                                    <h5
                                      style={{
                                        color: "white",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {getIdentificationType(
                                        currentConsultationDetail.vehicleConsult
                                          .ownerIdentificationType
                                      )}
                                    </h5>
                                  )}
                                {currentConsultationDetail.vehicleConsult &&
                                  currentConsultationDetail.vehicleConsult
                                    .infoVehiculo.placa && (
                                    <h5
                                      style={{
                                        color: "white",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {
                                        currentConsultationDetail.vehicleConsult
                                          .infoVehiculo.placa
                                      }
                                    </h5>
                                  )}

                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "end",
                                  }}
                                >
                                  <button
                                    style={{
                                      border: "none",
                                      background: "rgba(0,0,0,0.2)",
                                      borderRadius: "6px",
                                      color: "white",
                                      textAlign: "center",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      height: "36px",
                                      padding: "0 20px 0 20px",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setShowVehicleDetailModal(true);
                                    }}
                                  >
                                    Ver detalle vehículo
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                      <button
                        className="text-medium text-bold primary-color flex-row"
                        style={{
                          marginTop: "2%",
                          marginRight: "2%",
                          marginLeft: "1%",
                          marginBottom: "2%",
                          background: "rgba(0,0,0,0.4)",
                          paddingRight: "10px",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          paddingLeft: "10px",
                          borderRadius: "8px",
                          textAlign: "center",
                          cursor: "pointer",
                          width: "250px",
                          border: "none",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          setLoadingPdf(true);
                          let type: "PERSON" | "VEHICLE" = "PERSON";
                          if (
                            currentConsultationDetail.personType ===
                              "REMOLQUE" ||
                            currentConsultationDetail.personType === "VEHICULO"
                          ) {
                            type = "VEHICLE";
                          }
                          await getPdfTusDatosAPI(
                            currentConsultationDetail.consultId,
                            type
                          );
                          setLoadingPdf(false);
                        }}
                      >
                        {loadingPdf ? (
                          <ClipLoader color="white" size="25px" />
                        ) : (
                          <>
                            Descargar Reporte en PDF
                            <DownloadIcon2 style={{ marginLeft: "10px" }} />
                          </>
                        )}
                      </button>
                    </div>
                  )}
              </div>
              {currentConsultationDetail.result &&
              currentConsultationDetail.result.dict_hallazgos ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "8px",
                    marginTop: "10px",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.2)",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "8px 8px 0px 0px",
                      background: "rgba(0,0,0,0.2)",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "30px",
                    }}
                  >
                    <h6
                      style={{
                        color: "rgba(255,255,255,0.6)",
                        fontSize: "14px",
                        margin: "0px",
                      }}
                    >
                      Fuentes con alertas
                    </h6>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      padding: "2%",
                    }}
                  >
                    <p
                      style={{
                        color: "rgba(255,255,255,0.8)",
                        fontSize: "12px",
                      }}
                    >
                      En el resultado de la consulta se encontraron las
                      siguientes alertas.
                    </p>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginBottom: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                          }}
                        >
                          <WarningIcon
                            style={{
                              color: "rgba(255,92,92,1)",
                              marginTop: "3px",
                            }}
                          />
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "600",
                              marginLeft: "10px",
                            }}
                          >
                            Fuentes Riesgo alto:
                          </h6>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "700",
                              marginBottom: "0",
                              marginRight: "10px",
                            }}
                          >
                            {
                              currentConsultationDetail.result.dict_hallazgos
                                .altos.length
                            }
                          </h6>
                          {currentConsultationDetail?.result?.dict_hallazgos
                            ?.altos?.length > 0 && (
                            <button
                              style={{
                                background: "rgba(0,0,0,0.3)",
                                borderRadius: "8px",
                                color: "white",
                                textAlign: "center",
                                border: "none",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: "3px 10px",
                                alignSelf: "end",
                              }}
                              onClick={() => {
                                setSelectedHallazgos(
                                  currentConsultationDetail.result
                                    .dict_hallazgos.altos
                                );
                                setShowHallazgosDetailModal(true);
                              }}
                            >
                              Ver detalle
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginBottom: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                          }}
                        >
                          <WarningIcon
                            style={{
                              color: "#FFAD0F",
                              marginTop: "3px",
                            }}
                          />
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "600",
                              marginLeft: "10px",
                            }}
                          >
                            Fuentes Riesgo medio:
                          </h6>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "700",
                              marginBottom: "0",
                              marginRight: "10px",
                            }}
                          >
                            {
                              currentConsultationDetail.result.dict_hallazgos
                                .medios.length
                            }
                          </h6>
                          {currentConsultationDetail?.result?.dict_hallazgos
                            ?.medios?.length > 0 && (
                            <button
                              style={{
                                background: "rgba(0,0,0,0.3)",
                                borderRadius: "8px",
                                color: "white",
                                textAlign: "center",
                                border: "none",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: "3px 10px",
                                alignSelf: "end",
                              }}
                              onClick={() => {
                                setSelectedHallazgos(
                                  currentConsultationDetail.result
                                    .dict_hallazgos.medios
                                );
                                setShowHallazgosDetailModal(true);
                              }}
                            >
                              Ver detalle
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginBottom: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                          }}
                        >
                          <WarningIcon
                            style={{
                              color: "#C7FF4F",
                              marginTop: "3px",
                            }}
                          />
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "600",
                              marginLeft: "10px",
                            }}
                          >
                            Fuentes Riesgo bajo:
                          </h6>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "700",
                              marginBottom: "0",
                              marginRight: "10px",
                            }}
                          >
                            {
                              currentConsultationDetail.result.dict_hallazgos
                                .bajos.length
                            }
                          </h6>
                          {currentConsultationDetail?.result?.dict_hallazgos
                            ?.bajos?.length > 0 && (
                            <button
                              style={{
                                background: "rgba(0,0,0,0.3)",
                                borderRadius: "8px",
                                color: "white",
                                textAlign: "center",
                                border: "none",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: "3px 10px",
                                alignSelf: "end",
                              }}
                              onClick={() => {
                                setSelectedHallazgos(
                                  currentConsultationDetail.result
                                    .dict_hallazgos.bajos
                                );
                                setShowHallazgosDetailModal(true);
                              }}
                            >
                              Ver detalle
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginBottom: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                          }}
                        >
                          <InfoIcon
                            style={{
                              color: "#4169e1",
                              marginTop: "3px",
                              height: "15px",
                              width: "15px",
                            }}
                          />
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "600",
                              marginLeft: "10px",
                            }}
                          >
                            Fuentes Informativas:
                          </h6>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "700",
                              marginBottom: "0",
                              marginRight: "10px",
                            }}
                          >
                            {
                              currentConsultationDetail.result.dict_hallazgos
                                .infos.length
                            }
                          </h6>
                          {currentConsultationDetail?.result?.dict_hallazgos
                            ?.infos?.length > 0 && (
                            <button
                              style={{
                                background: "rgba(0,0,0,0.3)",
                                borderRadius: "8px",
                                color: "white",
                                textAlign: "center",
                                border: "none",
                                fontSize: "12px",
                                fontWeight: "600",
                                padding: "3px 10px",
                                alignSelf: "end",
                              }}
                              onClick={() => {
                                setSelectedHallazgos(
                                  currentConsultationDetail.result
                                    .dict_hallazgos.infos
                                );
                                setShowHallazgosDetailModal(true);
                              }}
                            >
                              Ver detalle
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "8px",
                    marginTop: "10px",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.2)",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "8px 8px 0px 0px",
                      background: "rgba(0,0,0,0.2)",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "30px",
                    }}
                  >
                    <h6
                      style={{
                        color: "rgba(255,255,255,0.6)",
                        fontSize: "14px",
                        margin: "0px",
                      }}
                    >
                      Fuentes con alertas
                    </h6>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      borderRadius: "8px",
                      padding: "2%",
                    }}
                  >
                    <p
                      style={{
                        color: "rgba(255,255,255,0.8)",
                        fontSize: "12px",
                      }}
                    >
                      Hubo un error obteniendo las alertas de las fuentes
                    </p>
                  </div>
                </div>
              )}
            </div>
            <div
              className="flex-col"
              style={{
                height: "85%",
                width: "50%",
                justifyContent: "start",
                padding: "1%",
              }}
            >
              <div
                className="flex-row"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                {!currentUrl.includes("hyperFlow") && (
                  <div
                    style={{
                      display: "flex",
                      width: "32%",
                      flexDirection: "column",
                      alignItems: "center",
                      backgroundColor: "rgba(0,0,0,0.2)",
                      borderRadius: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "38px",
                        backgroundColor: "rgba(0,0,0,0.2)",
                        borderRadius: "8px 8px 0px 0px",
                      }}
                    >
                      <h6
                        style={{
                          color: "rgba(255,255,255,0.6)",
                          textAlign: "center",
                          margin: "0px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Estado
                      </h6>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "70px",
                        borderRadius: "0px 0px 8px 8px",
                      }}
                    >
                      <h6
                        style={{
                          color: "white",
                          textAlign: "center",
                          fontSize: "14px",
                          fontWeight: "600",
                          margin: "0px",
                        }}
                      >
                        {getStatusName(currentConsultationDetail)}
                      </h6>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    width: currentUrl.includes("hyperFlow") ? "100%" : "32%",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.2)",
                    borderRadius: "8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "38px",
                      backgroundColor: "rgba(0,0,0,0.2)",
                      borderRadius: "8px 8px 0px 0px",
                    }}
                  >
                    <h6
                      style={{
                        color: "rgba(255,255,255,0.6)",
                        textAlign: "center",
                        margin: "0px",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Fecha de consulta
                    </h6>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "70px",
                      borderRadius: "0px 0px 8px 8px",
                    }}
                  >
                    <h6
                      style={{
                        color: "white",
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "600",
                        margin: "0px",
                      }}
                    >
                      {formatDateStandar(currentConsultationDetail.createdAt)}
                    </h6>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "38px",
                      backgroundColor: "rgba(0,0,0,0.2)",
                      borderRadius: "8px 8px 0px 0px",
                    }}
                  >
                    <h6
                      style={{
                        color: "rgba(255,255,255,0.6)",
                        textAlign: "center",
                        margin: "0px",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Fuentes con error
                    </h6>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                      borderRadius: "0px 0px 8px 8px",
                    }}
                  >
                    <div
                      style={{
                        color: "white",
                        margin: "0px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        maxHeight: "300px",
                        width: "100%",
                        overflow: "auto",
                        padding: "10px",
                      }}
                    >
                      {currentConsultationDetail.result &&
                      currentConsultationDetail.result.errores ? (
                        currentConsultationDetail.result.errores.map(
                          (error) => {
                            return (
                              <p
                                style={{ color: "white", textAlign: "start" }}
                                key={error}
                              >
                                {error}
                              </p>
                            );
                          }
                        )
                      ) : (
                        <p style={{ color: "white", textAlign: "start" }}>
                          No se encontraron errores
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                {!currentUrl.includes("hyperFlow") && (
                  <div
                    style={{
                      display: "flex",
                      width: "32%",
                      flexDirection: "column",
                      alignItems: "center",
                      backgroundColor: "rgba(0,0,0,0.2)",
                      borderRadius: "8px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "38px",
                        backgroundColor: "rgba(0,0,0,0.2)",
                        borderRadius: "8px 8px 0px 0px",
                      }}
                    >
                      <h6
                        style={{
                          color: "rgba(255,255,255,0.6)",
                          textAlign: "center",
                          margin: "0px",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Fecha de actualización
                      </h6>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "70px",
                        borderRadius: "0px 0px 8px 8px",
                      }}
                    >
                      <h6
                        style={{
                          color: "white",
                          textAlign: "center",
                          fontSize: "14px",
                          fontWeight: "600",
                          margin: "0px",
                        }}
                      >
                        {formatDateStandar(currentConsultationDetail.updatedAt)}
                      </h6>
                    </div>
                  </div>
                )}
              </div>
              {currentConsultationDetail?.result &&
                !currentUrl.includes("hyperFlow") && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: "8px",
                      alignItems: "center",
                      backgroundColor: "rgba(0,0,0,0.2)",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: "8px 8px 0px 0px",
                        background: "rgba(0,0,0,0.2)",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "30px",
                      }}
                    >
                      <h6
                        style={{
                          color: "rgba(255,255,255,0.6)",
                          fontSize: "14px",
                          margin: "0px",
                        }}
                      >
                        Resumen Consulta
                      </h6>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        padding: "2%",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          background: "rgba(0,0,0,0.2)",
                          borderRadius: "8px",
                          padding: "2%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <h6
                          style={{
                            color: "white",
                            fontSize: "16px",
                            fontWeight: "600",
                          }}
                        >
                          Fuentes con error
                        </h6>
                        <p
                          style={{
                            color: "rgba(255,255,255,0.8)",
                            fontSize: "12px",
                            marginBottom: "5px",
                          }}
                        >
                          Las siguientes fuentes no se pudieron ejecutar debido
                          a su disponibilidad, si requiere verificar alguna de
                          estas fuentes, puede reejecutar la consulta para estas
                          fuentes únicamente.
                        </p>
                        {currentConsultationDetail.executingRetry ? (
                          <h6
                            style={{
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            "Reejecutando fuentes"
                          </h6>
                        ) : (
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            {currentConsultationDetail.result.errores &&
                              currentConsultationDetail.result.errores.map(
                                (error, index) => (
                                  <h6
                                    style={{
                                      color: "white",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                    key={index}
                                  >
                                    {listNameConvert(error)}
                                  </h6>
                                )
                              )}
                          </div>
                        )}
                        <button
                          disabled={currentConsultationDetail.executingRetry}
                          style={{
                            background: "rgba(0,0,0,0.3)",
                            borderRadius: "8px",
                            color: "white",
                            textAlign: "center",
                            border: "none",
                            fontSize: "14px",
                            fontWeight: "600",
                            height: "35px",
                            padding: "0 20px 0 20px",
                            alignSelf: "end",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(
                              retryConsultation(currentConsultationDetail.id)
                            );
                          }}
                        >
                          {currentConsultationDetail.executingRetry
                            ? "Ejecutando fuentes"
                            : "Reejecutar consulta"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              padding: "1%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "8px",
                alignItems: "center",
                backgroundColor: "rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "8px 8px 0px 0px",
                  background: "rgba(0,0,0,0.2)",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "30px",
                }}
              >
                <h6
                  style={{
                    color: "rgba(255,255,255,0.6)",
                    fontSize: "14px",
                    margin: "0px",
                  }}
                >
                  Detalle de las fuentes consultadas
                </h6>
              </div>
              {currentConsultationDetail.result && (
                <div
                  style={{
                    width: "98%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: "8px",
                    background: "rgba(0,0,0,0.2)",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "10px 0px",
                    padding: "10px 10px",
                  }}
                >
                  {Object.entries(currentConsultationDetail.result).map(
                    (result, index) => {
                      if (
                        result[0] === "contadores_s" ||
                        result[0] === "errores" ||
                        result[0] === "contaduria" ||
                        result[0] === "dest" ||
                        result[0] === "dict_hallazgos" ||
                        result[0] === "error" ||
                        result[0] === "fecha" ||
                        result[0] === "genero" ||
                        result[0] === "hallazgos" ||
                        result[0] === "id" ||
                        result[0] === "monitoring_date" ||
                        result[0] === "nombre" ||
                        result[0] === "nombre-procuraduria" ||
                        result[0] === "ofac_nombre" ||
                        result[0] === "ofac_resultados" ||
                        result[0] === "peps_denom" ||
                        result[0] === "peps_version" ||
                        result[0] === "peps_consolidado" ||
                        result[0] === "personeriabog" ||
                        result[0] === "source_config" ||
                        result[0] === "secop_s" ||
                        result[0] === "relacionados" ||
                        result[0] === "typedoc" ||
                        result[0] === "plan" ||
                        result[0] === "Estado" ||
                        result[0] === "fecha_expedicion"
                      ) {
                        return <></>;
                      }
                      return (
                        <ExpandibleContent
                          title={listNameConvert(result[0])}
                          isActive={expandedElementId == result[0]}
                          titleAlign="start"
                          alert={hasAlert(
                            result[0],
                            currentConsultationDetail.result.dict_hallazgos
                              .altos,
                            currentConsultationDetail.result.dict_hallazgos
                              .medios
                          )}
                          content={showDataResult(result[0], result[1])}
                          onClickFunction={() => {
                            if (expandedElementId != result[0]) {
                              setExpandedElementId(result[0]);
                            }
                          }}
                          key={index}
                        />
                      );
                    }
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          className="flex-col"
          style={{
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1 className="text-huge text-bold primary-color">
            {detailLoading === "rejected"
              ? "No existe la consulta con el id proporcionado"
              : ""}
          </h1>
        </div>
      )}
    </LoadingOverlay>
  );
};
